import React, { useState,useEffect } from 'react'
import {Link, Grid ,Popover,CircularProgress,Checkbox,useTheme,useMediaQuery,Tooltip} from "@mui/material"
import Typography from '@mui/material/Typography';
import upiImg from '../../assets/images/VtrenderChartsUPI.png';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/DoneAll';
import PlusIcon from '@mui/icons-material/Add';
import ArrowIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { motion } from 'framer-motion';
import { URL } from '../../common/api/urls';
import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import useAuth from '../../common/hooks/useAuth';
// import bannerImg from '../../assets/images/diwali-banner4.jpeg';
// import bannerImg from '../../assets/images/hny-banner5.jpg';
// import bannerImg from '../../assets/images/republic-banner1.jpg';
// import bannerImg from '../../assets/images/freedom-top-banner.png';
// import miniBannerImg from '../../assets/images/mini-banner1.jpeg';
// import miniBannerImg from '../../assets/images/independence26-banner.jpeg';
import miniBannerImg from '../../assets/images/diwali26-banner.jpeg';
import axios from 'axios';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import useRefreshToken from '../../common/hooks/useRefreshToken';
import { useNavigate, useLocation } from 'react-router-dom';
import { SUBSCRIPTION_PLAN_LIST,SUBSCRIPTION_PLAN_TYPE,SNACKBAR_AUTO_HIDE_DURATION_SHORT,TEXT_MSGS,PAYMENT_STATUS,SUBSCRIPTION_PLANS,SUBSCRIPTION_PLANS_NEW, SUBSCRIPTION_PLANS_NSE_NEW, PAYMENT_METHOD_CCAVENUE, EXCHANGE_MODES, VMR_PLANS_MAP } from '../../common/utility/constant';
import $ from 'jquery';
import Popper from '@mui/material/Popper';
import { Radio } from 'antd';
import LinkIcon from '@mui/icons-material/Link';
import AppErrorPopup from '../../components/AppErrorPopup';
import OrderDetailPopup from './components/order_detail_popup';
import LoginModal from '../../components/landing/sections/LoginPopupNew';
// import MayResetOfferBanner from './components/MayResetOfferBanner';
import StarRateIcon from "@mui/icons-material/StarRate";
import Header from '../login-register/components/header';
import MainLayoutContainer from '../login-register/components/main-layout';
import { useAxios } from '../../common/api/hooks/useAxios';
import PricingBreakdown from '../../components/PricingBreakdown/PricingBreakdown';
import SubscriberAgreementPopup from './components/subscriber_agreement_popup';
import CountdownTimer from './components/countdown_timer';
import {
  captureChartsPricingViewed,
  captureChartsUpgradeClicked,
} from '../../analytics/chartsFunnel';
// import { Checkbox } from 'antd';

// Color constants 
const COLORS = {
  background: '#070D18',
  cardBg: 'rgba(14, 22, 36, 0.86)',
  primaryBlue: '#36C2B4',
  textPrimary: '#E7EEF8',
  textSecondary: '#97A6BA',
  success: '#2ED08A',
  borderLight: 'rgba(134, 152, 180, 0.3)',
  borderHover: 'rgba(54, 194, 180, 0.55)',
  variantActive: '#36C2B4',
  variantInactive: 'rgba(54, 194, 180, 0.24)',
  bseGold: '#F2A060',
  bseGoldLight: '#9D6AF8',
  bseGoldBg: 'rgba(242, 160, 96, 0.12)',
  accentPurple: '#9D6AF8',
  accentPurpleDark: '#7F53E0',
  eliteOrange: '#F2A060',
  eliteOrangeDark: '#E4894C',
  proRataWarm: '#FFB46E',
  proRataWarmDark: '#FF8A5C',
  proRataRose: '#F36FA8',
  proRataRoseDark: '#D85795',
};

// pricing card styling - UNIFORM WIDTH AND HEIGHT for cards
const modernCardSX = {
  width: 480, // Fixed width for cards
  minHeight: 1300, // Minimum height to accommodate organized content
  display: "flex", 
  flexDirection: 'column',
  alignItems: 'center',
  padding: 3, // Increased padding for better content spacing
  backgroundColor: COLORS.cardBg,
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  borderRadius: 4,
  border: `1px solid ${COLORS.borderLight}`,
  position: 'relative',
  transition: 'all 0.3s ease',
  "&:hover": {
    borderColor: COLORS.borderHover,
    transform: 'translateY(-8px)',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.3)'
  }
};

const premiumCardSX = {
  ...modernCardSX,
  border: `2px solid ${COLORS.primaryBlue}`,
  boxShadow: `0 10px 30px rgba(54, 194, 180, 0.22)`,
};

const modernButtonSX = {
  width: 350, // Increased width to match larger card 
  mb: 1,
  fontSize: 16,
  height: 45,
  background: `linear-gradient(135deg, ${COLORS.primaryBlue}, ${COLORS.accentPurple})`,
  color: COLORS.textPrimary,
  borderRadius: 3,
  fontWeight: 600,
  "&:hover": {
    background: `linear-gradient(135deg, ${COLORS.primaryBlue}, ${COLORS.accentPurpleDark})`,
    boxShadow: '0 6px 20px rgba(157, 106, 248, 0.4)',
    transform: 'translateY(-2px)',
  },
};

// Helper component for features with tooltips
const FeatureItem = ({ icon, text, tooltip, highlight = false }) => (
  <Box display='flex' sx={{ mb: 1.5, alignItems: 'center' }}>
    {icon}
    <Typography sx={{
      fontSize: "16px",
      ml: 1,
      color: COLORS.textPrimary, //  white text
      fontWeight: highlight ? 600 : 400
    }}>
      {text}
    </Typography>
    {tooltip && (
      <Tooltip 
        title={tooltip}
        placement="right"
        arrow
        sx={{
          '& .MuiTooltip-tooltip': {
            bgcolor: 'rgba(12, 20, 33, 0.96)',
            color: COLORS.textPrimary,
            fontSize: '0.875rem',
            border: `1px solid ${COLORS.borderLight}`,
          }
        }}
      >
        <InfoOutlinedIcon sx={{ ml: 1, fontSize: 16, color: COLORS.textSecondary, cursor: 'pointer' }} />
      </Tooltip>
    )}
  </Box>
);


// Reusable Rupee Symbol component
const RupeeSymbol = () => (
  <span style={{ fontFamily: 'Noto Sans, sans-serif', fontWeight: 400 }}>₹</span>
);

// NSE Logo component
const NSELogo = () => (
  <img 
    src="https://www.nseindia.com/next-assets/images/NSE_Logo.svg" 
    alt="NSE" 
    style={{ 
      height: '16px', 
      marginLeft: '6px', 
      verticalAlign: 'middle',
      display: 'inline-block',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '2px 4px',
      borderRadius: '3px'
    }} 
  />
);

const BSELogo = () => (
  <img
    src="https://www.bseindia.com/include/images/bselogo.png"
    alt="BSE"
    style={{
      height: '18px',
      marginLeft: '6px',
      verticalAlign: 'middle',
      display: 'inline-block',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '2px 4px',
      borderRadius: '3px'
    }}
  />
);

const SUBSCRIPTION_MONTHLY_TYPE={
    MONTHLY:"monthly",
    QUARTERLY:"quarterly",
    HALF_YEARLY:"half_yearly",
    ANNUALLY:"annually"
}

const SUBSCRIPTION_MONTHLY_TYPE_TEXT={
    MONTHLY:"per Month / Billed Monthly",
    QUARTERLY:"for Quarterly Plan / Billed Quarterly",
    HALF_YEARLY:"for Half-yearly Plan / Billed Half-yearly",
    ANNUALLY:"for Annual Plan / Billed Annually"
}

const BILLING_META = {
  monthly:    { period: 1,  label: SUBSCRIPTION_MONTHLY_TYPE_TEXT.MONTHLY },
  quarterly:  { period: 3,  label: SUBSCRIPTION_MONTHLY_TYPE_TEXT.QUARTERLY },
  half_yearly:{ period: 6,  label: SUBSCRIPTION_MONTHLY_TYPE_TEXT.HALF_YEARLY },
  annually:   { period: 12, label: SUBSCRIPTION_MONTHLY_TYPE_TEXT.ANNUALLY },
};

const VLD_ORDERFLOW_PLANS = [
  {
    id: 'vld-monthly',
    title: 'Monthly',
    periodKey: SUBSCRIPTION_MONTHLY_TYPE.MONTHLY,
    fallbackPrice: 19999,
    billingLabel: SUBSCRIPTION_MONTHLY_TYPE_TEXT.MONTHLY,
    planName: 'VLD_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1',
    featured: false,
    features: [
      'Live Orderflow & MarketProfile Charts',
      'Training Library Access',
      'Daily Audio Sessions',
    ],
  },
  {
    id: 'vld-quarterly',
    title: 'Quarterly',
    periodKey: SUBSCRIPTION_MONTHLY_TYPE.QUARTERLY,
    fallbackPrice: 49999,
    saveSuffix: '/quarter',
    billingLabel: SUBSCRIPTION_MONTHLY_TYPE_TEXT.QUARTERLY,
    planName: 'VLD_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3',
    featured: true,
    features: [
      'Live chart-based market observation',
      'Structured discussion on market behaviour',
      'Access to historical session recordings',
    ],
  },
  {
    id: 'vld-yearly',
    title: 'Yearly',
    periodKey: SUBSCRIPTION_MONTHLY_TYPE.ANNUALLY,
    fallbackPrice: 149999,
    saveSuffix: '/year',
    billingLabel: SUBSCRIPTION_MONTHLY_TYPE_TEXT.ANNUALLY,
    planName: 'VLD_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12',
    featured: false,
    features: [
      'MarketProfile & Orderflow Wisdom',
      'Long-term study of market structure',
      'Comprehensive Learning Access',
      'Ongoing exposure to evolving market conditions',
    ],
  },
];

const BILLING_PERIODS = Object.keys(BILLING_META);
const BSE_ELIGIBILITY_DAYS = 10;
const BSE_ADD_ON_ELIGIBILITY_DAYS = 29;
const BSE_TOP_UP_TERM = {
  MONTHLY: "monthly",
  FLEX: "flex",
};

// Promo copy lives in one place so coupon updates are low-effort later.
const PROMO_COUPON_CODE = "BSEBUNDLEPROMO";


const EXCHANGE_TAB_LABEL_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  minHeight: '100%',
  whiteSpace: 'nowrap',
};

const EXCHANGE_TAB_BADGE_NEW_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3px 9px',
  borderRadius: '6px',
  fontSize: '10px',
  lineHeight: 1.1,
  fontWeight: 700,
  letterSpacing: '0.6px',
  textTransform: 'uppercase',
  color: '#F4EEFF',
  background: 'linear-gradient(180deg, #B493FF 0%, #966AF6 100%)',
  border: '1px solid rgba(229, 216, 255, 0.34)',
};

const EXCHANGE_TAB_BADGE_BUNDLE_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3px 10px',
  borderRadius: '6px',
  fontSize: '10px',
  lineHeight: 1.1,
  fontWeight: 700,
  letterSpacing: '0.8px',
  textTransform: 'uppercase',
  color: '#8F5CFF',
  background: 'rgba(33, 18, 60, 0.86)',
  border: '1px solid rgba(143, 92, 255, 0.34)',
};


// Variant selector constants
const SUBSCRIPTION_VARIANT={
  ALL:"all", // All F&O (stocks + indices)
  INDEX:"index" // Index-only (Nifty/BankNifty/FinNifty)
}

const getAddOnPeriod = (tier = {}) => {
  const raw =
    tier?.period ??
    tier?.months ??
    tier?.duration_months ??
    tier?.puc_period ??
    1;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
};

const NSE_PLAN_NAMES = new Set(
  Object.values(SUBSCRIPTION_PLANS_NSE_NEW || {}).filter(
    (planName) => typeof planName === "string" && planName.startsWith("NSE_")
  )
);
const BSE_PLAN_NAMES = new Set(
  Object.values(SUBSCRIPTION_PLANS_NSE_NEW || {}).filter(
    (planName) => typeof planName === "string" && planName.startsWith("BSE_")
  )
);

const VMR_ADD_ON_ELIGIBLE_PLAN_NAMES = new Set([
  ...Object.keys(VMR_PLANS_MAP),
  ...Object.values(VMR_PLANS_MAP),
]);

const isNseOnlyPlanName = (planName = "") => NSE_PLAN_NAMES.has(planName);
const isVmrEligiblePlanName = (planName = "") => VMR_ADD_ON_ELIGIBLE_PLAN_NAMES.has(planName);
const isBsePlanName = (planName = "") => BSE_PLAN_NAMES.has(planName);

const resolveAddOnTierData = (addOnData, tierName, selectedTerm) => {
  const monthlyTier = addOnData?.[tierName];
  if (!monthlyTier) return null;

  if (selectedTerm === BSE_TOP_UP_TERM.FLEX) {
    const flexTier =
      addOnData?.flex?.[tierName] ||
      addOnData?.[`${tierName}_flex`] ||
      monthlyTier?.flex ||
      monthlyTier;

    return {
      ...flexTier,
      period: getAddOnPeriod(flexTier),
    };
  }

  return {
    ...monthlyTier,
    period: 1,
  };
};

const getBseAddOnEligibility = ({ activeSubscriptions = [], accessToken }) => {
  const activeNseOnlySubscriptions = activeSubscriptions.filter((item) =>
    isNseOnlyPlanName(item?.plan_name || "") || isVmrEligiblePlanName(item?.plan_name || "")
  );
  const hasActiveBsePlan = activeSubscriptions.some((item) =>
    isBsePlanName(item?.plan_name || "")
  );
  const nsePlanRemainingDays = activeNseOnlySubscriptions.reduce((maxDays, item) => {
    const planDays = Number(item?.days_to_expiry) || 0;
    return Math.max(maxDays, planDays);
  }, 0);

  const isEligible = nsePlanRemainingDays > BSE_ELIGIBILITY_DAYS && !hasActiveBsePlan;
  const shouldShowBseTab =
    Boolean(accessToken) &&
    isEligible;

  const isNsePlanAboveMinimumDays = nsePlanRemainingDays > BSE_ADD_ON_ELIGIBILITY_DAYS

  return {
    shouldShowBseTab,
    isNsePlanAboveMinimumDays,
    activeNseOnlySubscriptions
  };
};

const ShadowedTickIcon = ({
  size = 24,
  color = "whitesmoke",
  shadow = "2px 4px 3px rgba(0, 0, 0, 0.4)",
  sx = {},
  ...props
}) => {
  return (

   <>
   {" "}
    <DoneAllIcon
      {...props}
      sx={{
         filter: `drop-shadow(${shadow})`,
         color,
         fontSize: size,
         ...sx,
      }}
      />
   </>
  );
};

const Pricing = ({ hideLandingHeader = false, onSubscribeClick, onEcourseClick, onNamedPlanClick }) => {
  const from = "/login";
  const theme=useTheme();
  const isExchangeMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const exchangeTabHeight = isExchangeMobile ? '50px' : '62px';
  const exchangeTabWidth = isExchangeMobile ? '118px' : '230px';
  const exchangeTabPadding = isExchangeMobile ? '0 12px' : '0 28px';
  const navigate = useNavigate(); 
  const location = useLocation();
  const { auth } = useAuth();
  const refresh = useRefreshToken();
  const [SUBSCRIPTION_PLANS_PRICE_NSE,SET_SUBSCRIPTION_PLANS_PRICE_NSE]=useState(null)
  const [timerEnd, setTimerEnd] = useState(null);
  const {cancel,responseData,error,loaded,reset,executeAPI} = useAxios();
  const [cancelSubscription,responseDataSubcription,errorSubscription,loadedSubscription,resetSubscription,executeAPISubscription] = useAxiosWithAuth();
  // const [cancelOrder,responseDataOrder,errorOrder,loadedOrder,resetOrder,executeAPIOrder] = useAxiosWithAuth();
  // const [cancelStatus,responseDataStatus,errorStatus,loadedStatus,resetStatus,executeAPIStatus] = useAxiosWithAuth();
  const [cancelOrderDetail,responseDataOrderDetail,errorOrderDetail,loadedOrderDetail,resetOrderDetail,executeAPIOrderDetail] = useAxiosWithAuth();
  const [type, setType] = useState(SUBSCRIPTION_MONTHLY_TYPE.MONTHLY);
  const [typeText, setTypeText] = useState(SUBSCRIPTION_MONTHLY_TYPE_TEXT.MONTHLY);
  const [exchange, setExchange] = useState(EXCHANGE_MODES.NSE);
  const [period, setPeriod] = useState(1);
  const [monthlyDiscFactor, setMonthlyDiscFactor] = useState(1); // useState(0.85);
  const [vldPricing, setVldPricing] = useState(null);
  const [yearlyDiscFactor, setYearlyDiscFactor] = useState(0.8); // useState(0.6);
  const [variant,setVariant]=useState(SUBSCRIPTION_VARIANT.ALL);
  let monthlyDiscTxt = "";
  if(monthlyDiscFactor != 1) monthlyDiscTxt = " * "+monthlyDiscFactor;

  const getVldPriceView = (periodKey) => {
    const tier = vldPricing?.[periodKey]?.elite;
    if (!tier) return null;
    const periodMonths = BILLING_META[periodKey]?.period || 1;
    const stocks = Number(tier.stocks) || 0;
    const gst = Number(tier.stocks_gst) || 0;
    const total = Math.floor(monthlyDiscFactor * (stocks + gst));
    const actual = Number(tier.stocks_actual) || total;
    const pucAmount = Number(nsePucDomestic) || 0;
    const pucForPeriod = pucAmount * periodMonths;
    return {
      total,
      actual,
      hasDiscount: actual > total,
      savings: actual > total ? actual - total : 0,
      basePrice: stocks - pucForPeriod,
      pucAmount,
      pucPeriod: periodMonths,
      gstAmount: Math.floor(monthlyDiscFactor * gst),
      perMonth: periodMonths > 1 ? Math.floor(total / periodMonths) : null,
    };
  };

  const selectedSaveSuffix = {
    [SUBSCRIPTION_MONTHLY_TYPE.QUARTERLY]: '/quarter',
    [SUBSCRIPTION_MONTHLY_TYPE.HALF_YEARLY]: '/half-year',
    [SUBSCRIPTION_MONTHLY_TYPE.ANNUALLY]: '/year',
  }[type] || '';

  const renderBillingSavings = (currentPrice, actualPrice) => {
    if (!selectedSaveSuffix) return null;
    const savings = Number(actualPrice) - Number(currentPrice);
    if (!(savings > 0)) return null;
    return (
      <Typography sx={{ mb: 0, mt: '-4px', textAlign: 'center', fontSize: '14px', fontWeight: 600, color: COLORS.success, lineHeight: 1.2 }}>
        Save <RupeeSymbol />{savings.toLocaleString('en-IN')}{selectedSaveSuffix}
      </Typography>
    );
  };
  // Initialize with safe defaults - will be updated when API data loads
  // const [premiumTotal,setPremiumTotal]=useState(0);
  // const [premiumIndexTotal,setPremiumIndexTotal]=useState(0);
  const [professionalTotal,setProfessionalTotal]=useState(0);
  const [professionalIndexTotal,setProfessionalIndexTotal]=useState(0);
  const [professionalOFTotal,setProfessionalOFTotal]=useState(0);
  const [professionalOFIndexTotal,setProfessionalOFIndexTotal]=useState(0);

  // const [premiumTotalActual,setPremiumTotalActual]=useState(0);
  // const [premiumIndexTotalActual,setPremiumIndexTotalActual]=useState(0);
  const [professionalTotalActual,setProfessionalTotalActual]=useState(0);
  const [professionalIndexTotalActual,setProfessionalIndexTotalActual]=useState(0);
  const [professionalOFTotalActual,setProfessionalOFTotalActual]=useState(0);
  const [professionalOFIndexTotalActual,setProfessionalOFIndexTotalActual]=useState(0);
 


  // const [premiumBreakup,setPremiumBreakup]=useState("");
  // const [premiumIndexBreakup,setPremiumIndexBreakup]=useState("");
  const [professionalBreakup,setProfessionalBreakup]=useState("");
  const [professionalIndexBreakup,setProfessionalIndexBreakup]=useState("");
  const [professionalOFBreakup,setProfessionalOFBreakup]=useState("");
  const [professionalOFIndexBreakup,setProfessionalOFIndexBreakup]=useState("");
  const [professionalBreakup_i, setProfessionalBreakup_i] = useState("");
  const [professionalIndexBreakup_i, setProfessionalIndexBreakup_i] = useState("");
  const [professionalOFBreakup_i, setProfessionalOFBreakup_i] = useState("");
  const [professionalOFIndexBreakup_i, setProfessionalOFIndexBreakup_i] = useState("");
 

  const [nsePucDomestic,setNsePucDomestic]=useState();
  const [nsePucInternational,setNsePucInternational]=useState();
  const [bseFnoPuc,setBseFnoPuc]=useState(0);

  // International pricing state, toggle for all tiers
  const [isInternational, setIsInternational] = useState(false);
  const [isInternationalPremium, setIsInternationalPremium] = useState(false);
  const [isInternationalElite, setIsInternationalElite] = useState(false);
  const [professionalTotal_i, setProfessionalTotal_i] = useState(0);
  const [professionalIndexTotal_i, setProfessionalIndexTotal_i] = useState(0);
  const [professionalOFTotal_i, setProfessionalOFTotal_i] = useState(0);
  const [professionalOFIndexTotal_i, setProfessionalOFIndexTotal_i] = useState(0);
  const [professionalTotal_i_Actual, setProfessionalTotal_i_Actual] = useState(0);
  const [professionalIndexTotal_i_Actual, setProfessionalIndexTotal_i_Actual] = useState(0);
  const [professionalOFTotal_i_Actual, setProfessionalOFTotal_i_Actual] = useState(0);
  const [professionalOFIndexTotal_i_Actual, setProfessionalOFIndexTotal_i_Actual] = useState(0);

  const [ecourseAlreadyBought,setEcourseAlreadyBought]=useState(false);
  const [stockVal,setStockVal]=useState(false);
  const [orderflowVal,setOrderflowVal]=useState(false);
  const [orderflowStockVal,setOrderflowStockVal]=useState(false);
  const [isPremiumUpgradeAllowed,setIsPremiumUpgradeAllowed]=useState(true);
  const [isProfessionalUpgradeAllowed,setIsProfessionalUpgradeAllowed]=useState(false);
  const [planName,setPlanName]=useState(undefined);
  const [showorderPopup,setShowOrderPopup]=useState(false);
  const [orderDetailsData,setOrderDetailsData]=useState();
  const [showLoginPopup,setShowLoginPopup]=useState(false);
  const [showSubscriberAgreement, setShowSubscriberAgreement] = useState(false);
  const [loginMsg,setLoginMsg]=useState(TEXT_MSGS.LOGIN_POPUP_MSG);
 

  const [subscriptionState,setSubscriptionState]=useState({
    isLoaded:false,
    isError:false,
    subsciptionData:undefined
  })

  const {isLoaded,isError, subsciptionData}=subscriptionState;

  const [userSubscriptionState,setUserSubscriptionState]=useState({
    isUserSubsLoaded:false,
    isErrorUserSubs:false,
    userSubsData:undefined
  })

  const {isUserSubsLoaded,userSubsData,isErrorUserSubs}=userSubscriptionState;

  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
  const { open, msg, severity } = msgState;
  const isBseAddOnSelected = exchange === EXCHANGE_MODES.BSE_TOP_UP;
  const showLimitedPromoOffer = exchange === EXCHANGE_MODES.NSE_BSE;

  const activeSubscriptions = userSubsData?.active_subscriptions || [];
  const { shouldShowBseTab, isNsePlanAboveMinimumDays, activeNseOnlySubscriptions } = getBseAddOnEligibility({
    activeSubscriptions,
    accessToken: auth?.accessToken,
  });
  
    
  const bseAddOnData =
    SUBSCRIPTION_PLANS_PRICE_NSE?.[SUBSCRIPTION_MONTHLY_TYPE.MONTHLY]?.[
      EXCHANGE_MODES.BSE_TOP_UP
    ];

  const hasActiveEliteNsePlan = activeNseOnlySubscriptions.some((item) => {
    const joined = `${item?.plan_name || ""} ${item?.description || ""}`.toUpperCase();
    return joined.includes("ORDERFLOW") || joined.includes("ELITE");
  });
  const hasActiveProfessionalNsePlan = activeNseOnlySubscriptions.some((item) => {
    const joined = `${item?.plan_name || ""} ${item?.description || ""}`.toUpperCase();
    return !joined.includes("ORDERFLOW") && !joined.includes("ELITE");
  });

  const bseAddOnTargetTier = hasActiveEliteNsePlan
      ? "elite"
      : hasActiveProfessionalNsePlan
        ? "professional"
        : null;

  const getBseTopUpMonthlyTotal = (tierData) => {
    if (!tierData) return null;
    const base = Number(tierData.base) || 0;
    const gstAmount = Number(tierData.base_gst) || 0;
    return base + gstAmount;
  };

  const bseTopUpProfessionalMonthly = getBseTopUpMonthlyTotal(bseAddOnData?.professional);
  const bseTopUpEliteMonthly = getBseTopUpMonthlyTotal(bseAddOnData?.elite);

  const bseTopUpBannerMonthlyPrice = hasActiveEliteNsePlan
    ? bseTopUpEliteMonthly
    : hasActiveProfessionalNsePlan
      ? bseTopUpProfessionalMonthly
      : 997;

  const bseAddOnTierConfigs = [
    {
      key: "professional",
      actionLabel: "Purchase",
      color: COLORS.primaryBlue,
      planType: SUBSCRIPTION_PLAN_TYPE.PROFESSIONAL,
    },
    {
      key: "elite",
      actionLabel: "Purchase",
      color: "#EC6C10",
      planType: SUBSCRIPTION_PLAN_TYPE.ELITE,
    },
  ];

  const visibleAddOnTiers = auth?.accessToken
    ? bseAddOnTierConfigs.filter((tier) => tier.key === bseAddOnTargetTier)
    : bseAddOnTierConfigs;

  const bseAddOnCards = visibleAddOnTiers.flatMap((tierConfig) => {
    const monthlyTierData = resolveAddOnTierData(
      bseAddOnData,
      tierConfig.key,
      BSE_TOP_UP_TERM.MONTHLY
    );
    const flexTierData = resolveAddOnTierData(
      bseAddOnData,
      tierConfig.key,
      BSE_TOP_UP_TERM.FLEX
    );

    const cards = [];

    if (isNsePlanAboveMinimumDays) {
      cards.push({
        ...tierConfig,
        term: BSE_TOP_UP_TERM.MONTHLY,
        termLabel: "1 month Only",
        tierData: monthlyTierData,
      });
    }

    cards.push({
      ...tierConfig,
      term: BSE_TOP_UP_TERM.FLEX,
      termLabel: "Remaining full plan term",
      tierData: flexTierData,
    });

    return cards;
  });

  useEffect(() => {
    document.title = "Subscription Plans";
    captureChartsPricingViewed({
      pricing_surface: hideLandingHeader ? 'subscription' : 'pricing',
    });
    executeAPI(URL.GET_SUBSCRIPTION_PLANS_NEW,"GET",{}); 
    // Only call user subscription API if user is logged in
    if (auth?.accessToken) {
      executeAPISubscription(URL.USER_SUBSCRIPTION,"GET",{});
    }
  }, [auth?.accessToken]);

   /**
   * API response handler subscription data
   */  
  useEffect(() => {
      if (!loaded) return;

      if (responseData?.success) {
        const apiData = responseData.data || {};
        const bseData = responseData.bse_data || {};
        const addonData = responseData.addon_data || {};
        setVldPricing(responseData.vld_data || null);
        setTimerEnd(responseData.timer_end || null);

        const normalizedPricing = {};

        BILLING_PERIODS.forEach((period) => {
          normalizedPricing[period] = {};

          // NSE Pricing
          if (apiData[period]) {
            normalizedPricing[period][EXCHANGE_MODES.NSE] = {
              free: {
                base: 0,
                base_gst: 0,
                stocks: 0,
                stocks_gst: 0
              },
              professional: apiData[period].professional || {},
              elite: apiData[period].elite || {}
            };
          }

          // NSE + BSE Combined Pricing
          if (bseData[period]) {
            normalizedPricing[period][EXCHANGE_MODES.NSE_BSE] = {
              free: {
                base: 0,
                base_gst: 0,
                stocks: 0,
                stocks_gst: 0
              },
              professional: bseData[period].professional || {},
              elite: bseData[period].elite || {}
            };
          }
        });

        // BSE Top-Up (Monthly Only)
        if (addonData?.professional || addonData?.elite) {
          normalizedPricing[SUBSCRIPTION_MONTHLY_TYPE.MONTHLY][
            EXCHANGE_MODES.BSE_TOP_UP
          ] = {
            free: {
              base: 0,
              base_gst: 0,
              stocks: 0,
              stocks_gst: 0
            },
            professional: addonData.professional || {},
            elite: addonData.elite || {}
          };
        }

        SET_SUBSCRIPTION_PLANS_PRICE_NSE(normalizedPricing);

        // PUC Values
        if (responseData.dom_puc !== undefined)
          setNsePucDomestic(responseData.dom_puc);

        if (responseData.int_puc !== undefined)
          setNsePucInternational(responseData.int_puc);

        if (responseData.bse_fno_puc !== undefined)
          setBseFnoPuc(responseData.bse_fno_puc);

        setSubscriptionState({
          isLoaded: true,
          isError: false,
          subsciptionData: normalizedPricing
        });

      } else if (error) {

        SET_SUBSCRIPTION_PLANS_PRICE_NSE(null);
        setVldPricing(null);

        setSubscriptionState({
          isLoaded: true,
          isError: true,
          subsciptionData: undefined
        });

        setMsgState({
          open: true,
          msg: error?.response?.data?.message ?? TEXT_MSGS.NETWORK_ERROR_MSG,
          severity: "error"
        });

        if (error?.response?.status === 401 || error?.response?.status === 403) {
          navigate(from, { replace: true });
        }
      }

      reset();

    }, [loaded, responseData]);

  /**
   * API response handler for user subscription data
   */
  useEffect(() => {
    if(loadedSubscription){
      if(responseDataSubcription!=null && responseDataSubcription.success){
        setUserSubscriptionState({
          isUserSubsLoaded:true,
          isErrorUserSubs:false,
          userSubsData:responseDataSubcription.data
        })
      }
      else if(errorSubscription!==null){
        setUserSubscriptionState({
          isUserSubsLoaded:true,
          isErrorUserSubs:true,
          userSubsData:undefined
        })
        setMsgState({open:true,msg:errorSubscription?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        if(errorSubscription?.response?.status === 401 || errorSubscription?.response?.status === 403){
          console.log("status received =",errorSubscription?.response?.status)
          // Don't redirect, just show error message
        }
      }
      resetSubscription();
    }
  },[loadedSubscription,responseDataSubcription]);

  useEffect(() => {
    if (!SUBSCRIPTION_PLANS_PRICE_NSE) return;

    if (exchange === EXCHANGE_MODES.BSE_TOP_UP) {
      const addOnData = SUBSCRIPTION_PLANS_PRICE_NSE?.[type]?.[EXCHANGE_MODES.BSE_TOP_UP];
      if (!addOnData) return;

      if (addOnData.professional) {
        const p = addOnData.professional;
        const total = Math.floor(monthlyDiscFactor * (p.base + p.base_gst));
        setProfessionalTotal(total);
        setProfessionalIndexTotal(total);
        setProfessionalTotalActual(total);
        setProfessionalIndexTotalActual(total);
        setProfessionalBreakup(`(= ${p.base} + ${Math.floor(monthlyDiscFactor * p.base_gst)} GST)`);
        setProfessionalIndexBreakup(`(= ${p.base} + ${Math.floor(monthlyDiscFactor * p.base_gst)} GST)`);
      }

      if (addOnData.elite) {
        const e = addOnData.elite;
        const total = Math.floor(monthlyDiscFactor * (e.base + e.base_gst));
        setProfessionalOFTotal(total);
        setProfessionalOFIndexTotal(total);
        setProfessionalOFTotalActual(total);
        setProfessionalOFIndexTotalActual(total);
        setProfessionalOFBreakup(`(= ${e.base} + ${Math.floor(monthlyDiscFactor * e.base_gst)} GST)`);
        setProfessionalOFIndexBreakup(`(= ${e.base} + ${Math.floor(monthlyDiscFactor * e.base_gst)} GST)`);
      }

      return;
    }

    const currentPeriod = SUBSCRIPTION_PLANS_PRICE_NSE?.[type]?.[exchange];
    if (!currentPeriod) return;

    const pucDomestic =
      exchange === EXCHANGE_MODES.NSE
        ? (typeof nsePucDomestic !== "undefined" ? nsePucDomestic : 0)
        : ((nsePucDomestic ?? 0) + (bseFnoPuc ?? 0));

    const pucForPeriod = pucDomestic * period;

    /* -------------------- PROFESSIONAL -------------------- */
    if (currentPeriod.professional) {
      const p = currentPeriod.professional;

      const profTotal = Math.floor(
        monthlyDiscFactor * (p.stocks + p.stocks_gst)
      );

      setProfessionalTotal(profTotal);
      setProfessionalIndexTotal(
        Math.floor(monthlyDiscFactor * (p.base + p.base_gst))
      );

      setProfessionalTotalActual(p.stocks_actual || profTotal);
      setProfessionalIndexTotalActual(
        p.base_actual ||
          Math.floor(monthlyDiscFactor * (p.base + p.base_gst))
      );

      setProfessionalBreakup(
        `(= ${p.stocks - pucForPeriod}${monthlyDiscTxt} + ${pucDomestic} × ${period} + ${Math.floor(
          monthlyDiscFactor * p.stocks_gst
        )} GST)`
      );

      setProfessionalIndexBreakup(
        `(= ${p.base - pucForPeriod}${monthlyDiscTxt} + ${pucDomestic} × ${period} + ${Math.floor(
          monthlyDiscFactor * p.base_gst
        )} GST)`
      );
    }

    /* -------------------- ELITE -------------------- */
    if (currentPeriod.elite) {
      const e = currentPeriod.elite;

      const eliteTotal = Math.floor(
        monthlyDiscFactor * (e.stocks + e.stocks_gst)
      );

      setProfessionalOFTotal(eliteTotal);
      setProfessionalOFIndexTotal(
        Math.floor(monthlyDiscFactor * (e.base + e.base_gst))
      );

      setProfessionalOFTotalActual(e.stocks_actual || eliteTotal);
      setProfessionalOFIndexTotalActual(
        e.base_actual ||
          Math.floor(monthlyDiscFactor * (e.base + e.base_gst))
      );

      setProfessionalOFBreakup(
        `(= ${e.stocks - pucForPeriod}${monthlyDiscTxt} + ${pucDomestic} × ${period} + ${Math.floor(
          monthlyDiscFactor * e.stocks_gst
        )} GST)`
      );

      setProfessionalOFIndexBreakup(
        `(= ${e.base - pucForPeriod}${monthlyDiscTxt} + ${pucDomestic} × ${period} + ${Math.floor(
          monthlyDiscFactor * e.base_gst
        )} GST)`
      );
    }

    /* -------------------- INTERNATIONAL (NSE ONLY) -------------------- */
    if (exchange === EXCHANGE_MODES.NSE) {
      const pucInternational =
        typeof nsePucInternational !== "undefined"
          ? nsePucInternational
          : 0;

      const pucForPeriod_i = pucInternational * period;

      if (currentPeriod.professional?.stocks_i) {
        const p = currentPeriod.professional;

        setProfessionalTotal_i(
          Math.floor(monthlyDiscFactor * (p.stocks_i + p.stocks_gst_i))
        );
        setProfessionalIndexTotal_i(
          Math.floor(monthlyDiscFactor * (p.base_i + p.base_gst_i))
        );

        setProfessionalTotal_i_Actual(
          p.stocks_actual_i ||
            Math.floor(monthlyDiscFactor * (p.stocks_i + p.stocks_gst_i))
        );
        setProfessionalIndexTotal_i_Actual(
          p.base_actual_i ||
            Math.floor(monthlyDiscFactor * (p.base_i + p.base_gst_i))
        );

        setProfessionalBreakup_i(
          `(= ${p.stocks_i - pucForPeriod_i}${monthlyDiscTxt} + ${pucInternational} × ${period} + ${Math.floor(
            monthlyDiscFactor * p.stocks_gst_i
          )} GST)`
        );

        setProfessionalIndexBreakup_i(
          `(= ${p.base_i - pucForPeriod_i}${monthlyDiscTxt} + ${pucInternational} × ${period} + ${Math.floor(
            monthlyDiscFactor * p.base_gst_i
          )} GST)`
        );
      }

      if (currentPeriod.elite?.stocks_i) {
        const e = currentPeriod.elite;

        setProfessionalOFTotal_i(
          Math.floor(monthlyDiscFactor * (e.stocks_i + e.stocks_gst_i))
        );
        setProfessionalOFIndexTotal_i(
          Math.floor(monthlyDiscFactor * (e.base_i + e.base_gst_i))
        );

        setProfessionalOFTotal_i_Actual(
          e.stocks_actual_i ||
            Math.floor(monthlyDiscFactor * (e.stocks_i + e.stocks_gst_i))
        );
        setProfessionalOFIndexTotal_i_Actual(
          e.base_actual_i ||
            Math.floor(monthlyDiscFactor * (e.base_i + e.base_gst_i))
        );

        setProfessionalOFBreakup_i(
          `(= ${e.stocks_i - pucForPeriod_i}${monthlyDiscTxt} + ${pucInternational} × ${period} + ${Math.floor(
            monthlyDiscFactor * e.stocks_gst_i
          )} GST)`
        );

        setProfessionalOFIndexBreakup_i(
          `(= ${e.base_i - pucForPeriod_i}${monthlyDiscTxt} + ${pucInternational} × ${period} + ${Math.floor(
            monthlyDiscFactor * e.base_gst_i
          )} GST)`
        );
      }
    }
  }, [
    SUBSCRIPTION_PLANS_PRICE_NSE,
    exchange,
    type,
    monthlyDiscFactor,
    nsePucDomestic,
    nsePucInternational,
    bseFnoPuc,
    period,
  ]);
     


 

 
  
 
  const handleClick = (
    planType,
    isIndex = false,
    isInternational = false,
    selectedAddOnTerm
  ) => {
    const isFlexAddOnSelection = selectedAddOnTerm === BSE_TOP_UP_TERM.FLEX;

    captureChartsUpgradeClicked({
      cta_surface: onSubscribeClick ? 'subscription_pricing' : 'public_pricing',
      upgrade_target: planType === SUBSCRIPTION_PLAN_TYPE.ELITE ? 'elite' : 'professional',
      plan_type: planType,
      billing_type: type,
    });

    // If onSubscribeClick callback is provided (for logged-in subscription page), use it
    if (onSubscribeClick) {
      if (isFlexAddOnSelection) {
        onSubscribeClick(
          planType,
          isIndex,
          isInternational,
          type,
          exchange,
          selectedAddOnTerm
        );
      } else {
        onSubscribeClick(
          planType,
          isIndex,
          isInternational,
          type,
          exchange
        );
      }
      return;
    }

    navigate(from, { 
      state: { 
        from:{pathname:"/subscription"}, 
        planType, 
        isIndex, 
        billingType: type, 
        variant,
        isInternational,
        ...(isFlexAddOnSelection ? { addOnTerm: selectedAddOnTerm } : {}),
      }
    },{ replace: true });
   
  };
  
  const handleNamedPlanClick = (namedPlan) => {
    captureChartsUpgradeClicked({
      cta_surface: onSubscribeClick ? 'subscription_pricing' : 'public_pricing',
      upgrade_target: 'elite',
      plan_type: namedPlan,
      billing_type: 'fixed',
      plan_name: namedPlan,
    });

    if (onNamedPlanClick) {
      onNamedPlanClick(namedPlan);
      return;
    }

    navigate(from, {
      state: {
        from: { pathname: '/subscription' },
        planName: namedPlan,
      },
    }, { replace: true });
  };

  const handleClickEcourse = (event) => {  
    // If onEcourseClick callback is provided (for logged-in subscription page), use it
    if (onEcourseClick) {
      onEcourseClick();
      return;
    }
    
    console.log("handleClickEcourse=");
    let plan_name=SUBSCRIPTION_PLANS.VMR_ECOURSE;
    setPlanName(plan_name);
    const data={"plan_name": plan_name,"status_check":1, "payment_method":PAYMENT_METHOD_CCAVENUE}
    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER,"POST",data)
  };

  

  /**
   * autoclosing of the snackbar msg bar 
   */ 
  const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
  };

  const recalculatePricing = ({
    pricing,
    type,
    exchange,
    period,
    variant,
    monthlyDiscFactor,
    nsePucDomestic,
    bseFnoPuc,
    nsePucInternational,
    isInternationalPremium,
    isInternationalElite,
  }) => {
    if (exchange === EXCHANGE_MODES.BSE_TOP_UP) {
      const addOnData = pricing?.[type]?.[EXCHANGE_MODES.BSE_TOP_UP];
      if (!addOnData) return;

      if (addOnData.professional) {
        const p = addOnData.professional;
        const total = Math.floor(monthlyDiscFactor * (p.base + p.base_gst));
        setProfessionalTotal(total);
        setProfessionalTotalActual(total);
        setProfessionalBreakup(`(= ${p.base} + ${Math.floor(monthlyDiscFactor * p.base_gst)} GST)`);
      }

      if (addOnData.elite) {
        const e = addOnData.elite;
        const total = Math.floor(monthlyDiscFactor * (e.base + e.base_gst));
        setProfessionalOFTotal(total);
        setProfessionalOFTotalActual(total);
        setProfessionalOFBreakup(`(= ${e.base} + ${Math.floor(monthlyDiscFactor * e.base_gst)} GST)`);
      }
      return;
    }

    const current =
      pricing?.[type]?.[exchange];

    if (!current) return;

    const pucDomestic = exchange === EXCHANGE_MODES.NSE
      ? (nsePucDomestic ?? 0)
      : ((nsePucDomestic ?? 0) + (bseFnoPuc ?? 0));
    const pucInternational = nsePucInternational ?? 0;

    const calc = (tier, isInternational, isIndex) => {
      const isNSE = exchange === EXCHANGE_MODES.NSE;
      const puc = isInternational && isNSE ? pucInternational : pucDomestic;

      const baseKey = isIndex ? "base" : "stocks";
      const gstKey  = `${baseKey}_gst`;
      const iKey    = `${baseKey}_i`;
      const iGstKey = `${baseKey}_gst_i`;
      const actualKey = `${baseKey}_actual`;
      const actualIKey = `${baseKey}_actual_i`;

      const price = isInternational && isNSE
        ? tier[iKey] + tier[iGstKey]
        : tier[baseKey] + tier[gstKey];

      const actual = isInternational && isNSE
        ? tier[actualIKey] ?? price
        : tier[actualKey] ?? price;

      return {
        total: Math.floor(monthlyDiscFactor * price),
        actual,
        breakup: `(= ${price - puc * period} + ${puc} × ${period} + ${Math.floor(monthlyDiscFactor * (isInternational ? tier[iGstKey] : tier[gstKey]))} GST)`
      };
    };

    // PROFESSIONAL
    if (current.professional) {
      const res = calc(
        current.professional,
        isInternationalPremium,
        variant === SUBSCRIPTION_VARIANT.INDEX
      );

      setProfessionalTotal(res.total);
      setProfessionalTotalActual(res.actual);
      setProfessionalBreakup(res.breakup);
    }

    // ELITE
    if (current.elite) {
      const res = calc(
        current.elite,
        isInternationalElite,
        variant === SUBSCRIPTION_VARIANT.INDEX
      );

      setProfessionalOFTotal(res.total);
      setProfessionalOFTotalActual(res.actual);
      setProfessionalOFBreakup(res.breakup);
    }
  };

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    if (isBseAddOnSelected && selectedType !== SUBSCRIPTION_MONTHLY_TYPE.MONTHLY) return;
    setType(selectedType);

    const { period, label } = BILLING_META[selectedType];
    setTypeText(label);
    setPeriod(period);

    recalculatePricing({
      pricing: SUBSCRIPTION_PLANS_PRICE_NSE,
      type: selectedType,
      exchange,
      period,
      variant,
      monthlyDiscFactor,
      nsePucDomestic,
      bseFnoPuc,
      nsePucInternational,
      isInternationalPremium,
      isInternationalElite,
    });
  };



  const handleExchangeChange = (e) => {
    const selectedExchange = e.target.value;
    setExchange(selectedExchange);
    const isNSESelected = selectedExchange === EXCHANGE_MODES.NSE;
    const isBseAddOn = selectedExchange === EXCHANGE_MODES.BSE_TOP_UP;

    // 🚫 BSE DOES NOT SUPPORT INTERNATIONAL
    if (!isNSESelected) {
      setIsInternational(false);
      setIsInternationalPremium(false);
      setIsInternationalElite(false);
    }

    if (isBseAddOn) {
      setType(SUBSCRIPTION_MONTHLY_TYPE.MONTHLY);
      setTypeText(SUBSCRIPTION_MONTHLY_TYPE_TEXT.MONTHLY);
      setPeriod(1);
      setVariant(SUBSCRIPTION_VARIANT.INDEX);
    }

    recalculatePricing({
      pricing: SUBSCRIPTION_PLANS_PRICE_NSE,
      type: isBseAddOn ? SUBSCRIPTION_MONTHLY_TYPE.MONTHLY : type,
      exchange: selectedExchange,
      period: isBseAddOn ? 1 : period,
      variant,
      monthlyDiscFactor,
      nsePucDomestic,
      bseFnoPuc,
      nsePucInternational,
      isInternationalPremium: isNSESelected ? isInternationalPremium : false,
      isInternationalElite: isNSESelected ? isInternationalElite : false,
    });
  };



  const continuePayment=(code)=>{
    // console.log("COUPON CODE=",code);
    // setShowOrderPopup(false);
    // executeAPIOrder(URL.SUBSCRIPTION_ORDER,"POST",{"plan_name": planName,"status_check":0,"disc_coupon":code})
}

    return (
      <>
      {isLoaded?
       <MainLayoutContainer>
      {hideLandingHeader ? null : <Header showLogin={true} showIntro={true}/>}
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box sx={{
        background: `linear-gradient(to bottom, ${COLORS.background}, rgba(8, 14, 26, 0.95))`,
        minHeight: '100vh',
        pt: 8,
        pb: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100vw',
        ml: 'calc(50% - 50vw)',
        mr: 'calc(50% - 50vw)',
        justifyContent: 'flex-start',
        overflowX: 'auto'
      }}>
        <Typography variant="h3" component="div" sx={{
          mb: 2, mt: 3, textAlign: 'center',
          color: COLORS.textPrimary,
          fontSize: '2.5rem',
          fontWeight: 700
        }}>
          Subscription Plans
        </Typography>
        {/* <MayResetOfferBanner /> */}
        {/* <Typography variant="h4" sx={{mb:6,mt:4,ml:2,textAlign:'center',fontWeight:600,color:'#ffffff'}}>Happy 76th Republic Day! Get Additional 10% OFF on all Half-yearly and Annual plans.
          <br/>Use Coupon code <u style={{color:"#fa75e5"}}>REPUBLIC</u> on the Purchase Details popup.
          <br/>Offer valid only till 27th January. HURRY!</Typography> */}
        {/* <Typography variant="h4" sx={{mb:6,mt:4,ml:2,textAlign:'center',fontWeight:600,color:'#F3B23E'}}>Happy New Year! Get FLAT 30% OFF on all Annual plans and FLAT 20% OFF on all Half-yearly plans. 5% Savings on Quarterly plans.
          <br/>Use Coupon code <u style={{color:"#fa75e5"}}>HNY2026</u> on the Purchase Details popup.
          <br/>SPECIAL LIMITED PERIOD OFFER: Unlimited Access to ECourse on new Quarterly, Half-yearly and Annual plans subscription only.
          <br/>Offers valid only till 4th January. HURRY!</Typography> */}
        {/* <Typography variant="h4" sx={{mb:6,mt:4,ml:2,textAlign:'center',fontWeight:600,color:'#F3B23E'}}>Happy Republic day! Get FLAT 30% OFF on all Annual plans and FLAT 20% OFF on all Half-yearly plans. 5% Savings on Quarterly plans.
          <br/>Use Coupon code <u style={{color:"#fa75e5"}}>REPUBLIC26</u> on the Purchase Details popup.
          <br/>SPECIAL LIMITED PERIOD OFFER: Unlimited Access to ECourse on new Quarterly, Half-yearly and Annual plans subscription only.
          <br/>Offers valid only till 27th January. HURRY!</Typography> */}
        {/* <Typography variant="h4" sx={{mb:4,mt:5,textAlign:'center',fontWeight:600,color:'#acfb03'}}>NOTE: We have updated our plans and offerings to better align with our vision for future product enhancements.</Typography> */}
        {/* <Typography variant="h4" sx={{mb:4,mt:5,textAlign:'center',fontWeight:600,color:'#FBE103'}}>Special Diwali Offer - Save <u>MORE</u> when you subscribe to our Half-yearly and Annual plans.
        <br/>Higher Savings offer available only till <u>10th November</u>.
        <br/>HURRY and become a longer term member with the best possible prices Now!</Typography> */}
        {/* <Typography variant="h4" sx={{mb:4,mt:5,textAlign:'center',fontWeight:600,color:'#FBE103'}}>Special Independence Day Offer - Save <u>MORE</u> when you subscribe to our higher timeframe plans.
        <br/>Higher Savings offer available only till <u>18th Aug</u>.
        <br/>HURRY and become a longer term member with the best possible prices Now!</Typography> */}
        {/* <Typography variant="h4" sx={{mb:6,mt:4,textAlign:'center',fontWeight:600,color:'#FBE103'}}>Special Independence Day Offer - Get FLAT 20% OFF on all plans - Use Coupon code <u style={{color:"#F3B23E"}}>FREEDOM20</u> during checkout.
        <br/>Offer valid only till 20th Aug. HURRY!</Typography> */}
        {/* <Typography  sx={{mt:2,textAlign:'center',fontSize:"32px",fontWeight:600,color:'#F3B23E'}}>Stay tuned for our upcoming exciting new year discount offer on Annual Plans..</Typography> */}
        {/* <Typography variant="h4" sx={{mb:6,mt:4,ml:2,textAlign:'center',fontWeight:600,color:'#ffffff'}}>SPECIAL Limited Time Offer!<br/>Save 15%, 20% and 25% on Quarterly, Half-yearly and Annual plans respectively.
          <br/>Use Coupon code <u style={{color:"#fa75e5"}}>MAY1</u> on the Purchase Details popup.
          <br/>Offer valid only till 2nd May. HURRY!</Typography>
        <br/> */}
        {/* <Box sx={{display:"flex",justifyContent:"center"}}><img src={bannerImg} alt="hny_offer" style={imgStyle} /><br/></Box> */}
        <br/>
        <img src={miniBannerImg} alt="republic_offer" style={{width: "100%", marginLeft: 0, marginRight: 40, marginTop: 10, marginBottom: 20}} /><br/>
        {timerEnd? 
        <><CountdownTimer targetDate={timerEnd} customColor="#f5a8a8" />
        <br/></>
        :<></>}
       
        <Box sx={{mt:1,display:"flex",justifyContent:"center",flexDirection:'column',alignItems:'center',width:'100%',maxWidth:900}}>
          <Box sx={{display:'grid',gridTemplateColumns:'repeat(4, 1fr)',width:'100%',mb:0.3,'@media (max-width:900px)':{display:'none'}}}>
            <Box></Box>
            <Typography sx={{textAlign:'center',fontSize:"18px",fontWeight:600,color:COLORS.success,lineHeight:1.2,mb:0}}>Save 5%</Typography>
            <Typography sx={{textAlign:'center',fontSize:"18px",fontWeight:600,color:COLORS.success,lineHeight:1.2,mb:0}}>Save 10%</Typography>
            <Typography sx={{textAlign:'center',fontSize:"18px",fontWeight:600,color:COLORS.success,lineHeight:1.2,mb:0}}>Save 15%</Typography>
          </Box>
          <Box sx={{width:'100%',mt:0.3,display:'block','@media (max-width:900px)':{display:'none'}}}>
            <Radio.Group buttonStyle="solid" onChange={handleTypeChange} value={type} size="large" style={{display:'grid',gridTemplateColumns:'repeat(4, 1fr)'}}>
              <Radio.Button style={{
                fontSize:"20px",
                textAlign:'center',
                color: type === 'monthly' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'monthly' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.3)',
                borderColor: COLORS.borderLight,
                fontWeight: type === 'monthly' ? 600 : 400,
              }}value="monthly">Monthly{type === 'monthly' ? <ShadowedTickIcon/> : ''}</Radio.Button>
              <Radio.Button style={{
                fontSize:"20px",
                textAlign:'center',
                color: type === 'quarterly' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'quarterly' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.3)',
                borderColor: COLORS.borderLight,
                fontWeight: type === 'quarterly' ? 600 : 400,
                opacity: isBseAddOnSelected ? 0.45 : 1,
                cursor: isBseAddOnSelected ? 'not-allowed' : 'pointer',
                pointerEvents: isBseAddOnSelected ? 'none' : 'auto',
              }} value="quarterly">Quarterly{type === 'quarterly' ? <ShadowedTickIcon/> : ''}</Radio.Button>
              <Radio.Button style={{
                fontSize:"20px",
                textAlign:'center',
                color: type === 'half_yearly' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'half_yearly' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.3)',
                borderColor: COLORS.borderLight,
                fontWeight: type === 'half_yearly' ? 600 : 400,
                opacity: isBseAddOnSelected ? 0.45 : 1,
                cursor: isBseAddOnSelected ? 'not-allowed' : 'pointer',
                pointerEvents: isBseAddOnSelected ? 'none' : 'auto',
              }} value="half_yearly">Half-yearly{type === 'half_yearly' ? <ShadowedTickIcon/> : ''}</Radio.Button>
              <Radio.Button style={{
                fontSize:"20px",
                textAlign:'center',
                color: type === 'annually' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'annually' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.3)',
                borderColor: COLORS.borderLight,
                fontWeight: type === 'annually' ? 600 : 400,
                opacity: isBseAddOnSelected ? 0.45 : 1,
                cursor: isBseAddOnSelected ? 'not-allowed' : 'pointer',
                pointerEvents: isBseAddOnSelected ? 'none' : 'auto',
              }} value="annually">Annually{type === 'annually' ? <ShadowedTickIcon/> : ''}</Radio.Button>
            </Radio.Group>
          </Box>
          <Box sx={{
            width:'100%',
            mt:0.3,
            display:'none',
            '@media (max-width:900px)':{display:'flex',justifyContent:'center',px:1},
            '& .ant-radio-button-wrapper::before': { display: 'none !important' },
            '& .ant-radio-button-wrapper': { borderLeft: 'none !important' },
          }}>
            <Radio.Group
              buttonStyle="solid"
              onChange={handleTypeChange}
              value={type}
              size="large"
              style={{display:'grid',gridTemplateColumns:'1fr',gap:'10px',width:'100%',maxWidth:'460px'}}
            >
              <Radio.Button style={{
                fontSize:"18px",
                color: type === 'monthly' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'monthly' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.35)',
                border: 'none',
                borderRadius: '12px',
                fontWeight: type === 'monthly' ? 700 : 500,
                width: '600=',
                minHeight: '52px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
                boxShadow: type === 'monthly' ? '0 8px 22px rgba(0,0,0,0.35)' : '0 2px 10px rgba(0,0,0,0.18)',
                transition: 'all 0.2s ease',
              }} value="monthly">
                <span style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%',maxWidth:'340px',margin:'0 auto',gap:'16px'}}>
                  <span style={{display:'inline-flex',alignItems:'center',gap:'8px'}}>Monthly{type === 'monthly' ? <ShadowedTickIcon/> : ''}</span>
                  <span style={{fontSize:"15px",color:type === 'monthly' ? '#000000' : COLORS.success,fontWeight:700,minWidth:'92px',textAlign:'right',opacity:0.55}}>---</span>
                </span>
              </Radio.Button>
              <Radio.Button style={{
                fontSize:"18px",
                color: type === 'quarterly' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'quarterly' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.35)',
                border: 'none',
                borderRadius: '12px',
                fontWeight: type === 'quarterly' ? 700 : 500,
                opacity: isBseAddOnSelected ? 0.45 : 1,
                cursor: isBseAddOnSelected ? 'not-allowed' : 'pointer',
                pointerEvents: isBseAddOnSelected ? 'none' : 'auto',
                width: '600=',
                minHeight: '52px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
                boxShadow: type === 'quarterly' ? '0 8px 22px rgba(0,0,0,0.35)' : '0 2px 10px rgba(0,0,0,0.18)',
                transition: 'all 0.2s ease',
              }} value="quarterly">
                <span style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%',maxWidth:'340px',margin:'0 auto',gap:'16px'}}>
                  <span style={{display:'inline-flex',alignItems:'center',gap:'8px'}}>Quarterly{type === 'quarterly' ? <ShadowedTickIcon/> : ''}</span>
                  <span style={{fontSize:"15px",color:type === 'quarterly' ? '#000000' : COLORS.success,fontWeight:700,minWidth:'92px',textAlign:'right'}}>Save 5%</span>
                </span>
              </Radio.Button>
              <Radio.Button style={{
                fontSize:"18px",
                color: type === 'half_yearly' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'half_yearly' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.35)',
                border: 'none',
                borderRadius: '12px',
                fontWeight: type === 'half_yearly' ? 700 : 500,
                opacity: isBseAddOnSelected ? 0.45 : 1,
                cursor: isBseAddOnSelected ? 'not-allowed' : 'pointer',
                pointerEvents: isBseAddOnSelected ? 'none' : 'auto',
                width: '600=',
                minHeight: '52px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
                boxShadow: type === 'half_yearly' ? '0 8px 22px rgba(0,0,0,0.35)' : '0 2px 10px rgba(0,0,0,0.18)',
                transition: 'all 0.2s ease',
              }} value="half_yearly">
                <span style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%',maxWidth:'340px',margin:'0 auto',gap:'16px'}}>
                  <span style={{display:'inline-flex',alignItems:'center',gap:'8px'}}>Half-yearly{type === 'half_yearly' ? <ShadowedTickIcon/> : ''}</span>
                  <span style={{fontSize:"15px",color:type === 'half_yearly' ? '#000000' : COLORS.success,fontWeight:700,minWidth:'92px',textAlign:'right'}}>Save 10%</span>
                </span>
              </Radio.Button>
              <Radio.Button style={{
                fontSize:"18px",
                color: type === 'annually' ? COLORS.textPrimary : COLORS.textSecondary,
                backgroundColor: type === 'annually' ? COLORS.primaryBlue : 'rgba(23, 42, 69, 0.35)',
                border: 'none',
                borderRadius: '12px',
                fontWeight: type === 'annually' ? 700 : 500,
                opacity: isBseAddOnSelected ? 0.45 : 1,
                cursor: isBseAddOnSelected ? 'not-allowed' : 'pointer',
                pointerEvents: isBseAddOnSelected ? 'none' : 'auto',
                width: '600=',
                minHeight: '52px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
                boxShadow: type === 'annually' ? '0 8px 22px rgba(0,0,0,0.35)' : '0 2px 10px rgba(0,0,0,0.18)',
                transition: 'all 0.2s ease',
              }} value="annually">
                <span style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%',maxWidth:'340px',margin:'0 auto',gap:'16px'}}>
                  <span style={{display:'inline-flex',alignItems:'center',gap:'8px'}}>Annually{type === 'annually' ? <ShadowedTickIcon/> : ''}</span>
                  <span style={{fontSize:"15px",color:type === 'annually' ? '#000000' : COLORS.success,fontWeight:700,minWidth:'92px',textAlign:'right'}}>Save 15%</span>
                </span>
              </Radio.Button>
            </Radio.Group>
          </Box>
          
          <Box
            sx={{
               mt: 5,
               mb: 2,
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               gap: 2,
               '& .ant-radio-button-wrapper::before': { display: 'none !important' },
               '& .ant-radio-button-wrapper': {
                  flex: 1,
                  display: 'flex !important',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: `${exchangeTabHeight} !important`,
                  width: `${exchangeTabWidth} !important`,
                  padding: `${exchangeTabPadding} !important`,
                  border: 'none !important',
                  borderRadius: '13px !important',  
                  lineHeight: '1 !important',
               },
               '& .ant-radio-button-wrapper > span:last-child': {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  padding: 0,
               },
            }}
            >
            <Radio.Group
               buttonStyle="solid"
               onChange={handleExchangeChange}
               value={exchange}
               size="small"
               style={{
                  display: 'flex',
                  width: '100%',
                  maxWidth: '920px',               
                  background: 'rgba(13, 22, 36, 0.9)',
                  border: '1px solid rgba(134, 152, 180, 0.3)',
                  borderRadius: '16px',            
                  padding: '5px',                  
                  overflow: 'hidden',
                  boxShadow: '0 8px 20px rgba(3, 8, 16, 0.35)',
                  gap: '2px',
               }}
            >
               <Radio.Button
                  style={{
                  flex: 1,
                  height: '62px',                
                  width: '230px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  borderRadius: '13px',          
                  padding: '0 28px',             
                  color: exchange === EXCHANGE_MODES.NSE ? '#EAFEF8' : COLORS.textSecondary,
                  background: exchange === EXCHANGE_MODES.NSE
                     ? 'linear-gradient(180deg, rgba(30, 88, 69, 0.58), rgba(18, 52, 45, 0.82))'
                     : 'transparent',
                  fontWeight: exchange === EXCHANGE_MODES.NSE ? 700 : 600,
                  boxShadow: exchange === EXCHANGE_MODES.NSE
                     ? 'inset 0 1px 0 rgba(85, 232, 177, 0.14)'
                     : 'none',
                  }}
                  value={EXCHANGE_MODES.NSE}
               >
                  <span style={{ ...EXCHANGE_TAB_LABEL_STYLE, fontSize: '15px', gap: '9px' }}>
                  NSE F&O
                  {exchange === EXCHANGE_MODES.NSE ? <ShadowedTickIcon/> : ''}
                  </span>
               </Radio.Button>

               {shouldShowBseTab && (
                  <Radio.Button
                  style={{
                     flex: 1,
                     height: '62px',              
                     width: '230px',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     border: 'none',
                     borderRadius: '13px',        
                     padding: '0 28px',           
                     color: exchange === EXCHANGE_MODES.BSE_TOP_UP ? '#F0E7FF' : COLORS.textSecondary,
                     background: exchange === EXCHANGE_MODES.BSE_TOP_UP
                        ? 'linear-gradient(180deg, rgba(87, 72, 138, 0.64), rgba(58, 45, 103, 0.86))'
                        : 'transparent',
                     fontWeight: exchange === EXCHANGE_MODES.BSE_TOP_UP ? 700 : 600,
                     boxShadow: exchange === EXCHANGE_MODES.BSE_TOP_UP
                        ? 'inset 0 1px 0 rgba(204, 179, 255, 0.16)'
                        : 'none',
                  }}
                  value={EXCHANGE_MODES.BSE_TOP_UP}
                  >
                  <span style={{ ...EXCHANGE_TAB_LABEL_STYLE, fontSize: '15px', gap: '9px' }}>
                     BSE
                     <span style={EXCHANGE_TAB_BADGE_NEW_STYLE}>NEW</span>
                      {exchange === EXCHANGE_MODES.BSE_TOP_UP ? <ShadowedTickIcon/> : ''}
                  </span>
                  </Radio.Button>
               )}

               <Radio.Button
                  style={{
                  flex: 1,
                  height: '62px',                
                  display: 'flex',
                  width: '230px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  borderRadius: '13px',          
                  padding: '0 28px',             
                  color: exchange === EXCHANGE_MODES.NSE_BSE ? '#EDE4FF' : COLORS.textSecondary,
                  background: exchange === EXCHANGE_MODES.NSE_BSE
                     ? 'linear-gradient(180deg, rgba(82, 66, 136, 0.62), rgba(57, 44, 102, 0.84))'
                     : 'transparent',
                  fontWeight: exchange === EXCHANGE_MODES.NSE_BSE ? 700 : 600,
                  boxShadow: exchange === EXCHANGE_MODES.NSE_BSE
                     ? 'inset 0 1px 0 rgba(204, 179, 255, 0.16)'
                     : 'none',
                  }}
                  value={EXCHANGE_MODES.NSE_BSE}
               >
                  <span style={{ ...EXCHANGE_TAB_LABEL_STYLE, fontSize: '15px', gap: '9px' }}>
                  NSE + BSE
                  <span style={EXCHANGE_TAB_BADGE_BUNDLE_STYLE}>BUNDLE</span>
                   {exchange === EXCHANGE_MODES.NSE_BSE ? <ShadowedTickIcon/> : ''}
                  </span>
               </Radio.Button>
            </Radio.Group>
            </Box>
          <Typography sx={{ fontSize: '15px', fontWeight:600, color: COLORS.textSecondary, mb: 1, textAlign: 'center' }}>
            {exchange === EXCHANGE_MODES.NSE
              ? 'Access to data of NSE instruments only.'
              : exchange === EXCHANGE_MODES.NSE_BSE
                ? 'Bundle plans - Access to both NSE FnO and BSE Index FnO.'
                : 'BSE Add-on on top of existing NSE plan.'}
          </Typography>
          {/* Promo banner shown only on NSE+BSE and BSE Add-on flows */}
          {/* {showLimitedPromoOffer && (
            <Box
              sx={{
                mt: 1,
                mb: 2,
                p: 1.8,
                borderRadius: 2,
                width: '100%',
                maxWidth: '760px',
                mx: 'auto',
                background: 'linear-gradient(135deg, rgba(242, 160, 96, 0.16), rgba(157, 106, 248, 0.12))',
                border: '1px solid rgba(242, 160, 96, 0.45)',
                boxShadow: '0 2px 8px rgba(8, 14, 26, 0.28)',
              }}
            >
              <Typography sx={{ fontSize: '16px', fontWeight: 700, color: '#FBBF24', textAlign: 'center' }}>
                Limited Period Promo Offer - Flat 20% Off on all Bundle plans
              </Typography>
              <Typography sx={{ mt: 0.4, fontSize: '13px', color: COLORS.textPrimary, textAlign: 'center' }}>
                Coupon Code:{" "}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    color: '#FCD34D',
                    letterSpacing: '0.4px',
                    borderBottom: '1px dashed rgba(252, 211, 77, 0.7)',
                  }}
                >
                  {PROMO_COUPON_CODE}
                </Box>
              </Typography>
              <Typography sx={{ mt: 0.25, fontSize: '12px', color: COLORS.textSecondary, textAlign: 'center' }}>
                Valid for a limited time only.
              </Typography>
            </Box>
          )} */}

          {/* {(
            <Box
              sx={{
                mt: 1,
                mb: 2,
                p: 1.8,
                borderRadius: 2,
                width: '100%',
                maxWidth: '760px',
                mx: 'auto',
                background: 'linear-gradient(135deg, rgba(242, 160, 96, 0.16), rgba(157, 106, 248, 0.12))',
                border: '1px solid rgba(242, 160, 96, 0.45)',
                boxShadow: '0 2px 8px rgba(8, 14, 26, 0.28)',
              }}
            >
              <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#FBBF24', textAlign: 'center' }}>
                Our best offers with the highest discounts of the year are here.
              </Typography>
              <Typography sx={{ mt: 0.4, fontSize: '15px', color: COLORS.textPrimary, textAlign: 'center' }}>
                Coupon Code for Elite plans:{" "}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    color: '#FCD34D',
                    letterSpacing: '0.4px',
                    borderBottom: '1px dashed rgba(252, 211, 77, 0.7)',
                  }}
                >
                  ELFREE
                </Box>
              </Typography>
              <Typography sx={{ mt: 0.4, fontSize: '15px', color: COLORS.textPrimary, textAlign: 'center' }}>
                Coupon Code for Professional plans:{" "}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    color: '#FCD34D',
                    letterSpacing: '0.4px',
                    borderBottom: '1px dashed rgba(252, 211, 77, 0.7)',
                  }}
                >
                  PRFREE
                </Box>
              </Typography>
              <Typography sx={{ mt: 0.25, fontSize: '13px', color: COLORS.textSecondary, textAlign: 'center' }}>
                Valid for a limited time only.
              </Typography>
            </Box>
          )} */}
         
          {isBseAddOnSelected && auth?.accessToken && activeNseOnlySubscriptions && (
            <Box sx={{
              mt: 0.5,
              mb: 2,
              p: 1.8,
              borderRadius: 2,
              width: '100%',
              backgroundColor: 'rgba(16, 185, 129, 0.09)',
              border: '1px solid rgba(16, 185, 129, 0.35)',
            }}>
              <Typography sx={{ fontSize: '14px', color: '#6EE7B7', letterSpacing: '0.9px', textTransform: 'uppercase', fontWeight: 600 }}>
                Current Active Plans
              </Typography>
              {activeNseOnlySubscriptions.map((plans)=> (
              <><Typography sx={{ mt: 0.3, fontSize: '14px', color: COLORS.textPrimary, fontWeight: 600 }}>
                  {plans?.description}
                </Typography><Typography sx={{ mt: 0.2, fontSize: '14px', color: COLORS.textPrimary }}>
                    Validity remaining: {Number(plans?.days_to_expiry) || 0} day(s)
                  </Typography></>
              ))}
            </Box>
          )}
        {/* Variant selector: All F&O vs Index-only */}
        {!isBseAddOnSelected && (
          <>
            <br/>
            <Box sx={{width:'80%', mt: 2}}>
              <Radio.Group
                buttonStyle="solid"
                value={variant}
                onChange={(e)=>setVariant(e.target.value)}
                size="large"
                style={{display:'grid',gridTemplateColumns:'repeat(2, 1fr)'}}
              >
                <Radio.Button
                  style={{
                    fontSize:"18px",
                    textAlign:'center',
                    color: variant === SUBSCRIPTION_VARIANT.INDEX ? COLORS.textPrimary : COLORS.textSecondary,
                    backgroundColor: variant === SUBSCRIPTION_VARIANT.INDEX ? COLORS.variantActive : COLORS.variantInactive,
                    borderColor: COLORS.variantActive,
                    height: "80px",
                    lineHeight: "25px",
                    paddingTop: "10px",
                    fontWeight: variant === SUBSCRIPTION_VARIANT.INDEX ? 600 : 400,
                  }}
                  value={SUBSCRIPTION_VARIANT.INDEX}
                >
                  {exchange === EXCHANGE_MODES.NSE_BSE ? 'NSE Index + BSE Index' : 'Index-only'}{variant === SUBSCRIPTION_VARIANT.INDEX ? <ShadowedTickIcon/> : ''} <br/>(non-stocks F&O)
                </Radio.Button>
                <Radio.Button
                  style={{
                    fontSize:"18px",
                    textAlign:'center',
                    color: variant === SUBSCRIPTION_VARIANT.ALL ? COLORS.textPrimary : COLORS.textSecondary,
                    backgroundColor: variant === SUBSCRIPTION_VARIANT.ALL ? COLORS.variantActive : COLORS.variantInactive,
                    borderColor: COLORS.variantActive,
                    height: "80px",
                    lineHeight: "25px",
                    paddingTop: "10px",
                    fontWeight: variant === SUBSCRIPTION_VARIANT.ALL ? 600 : 400,
                  }}
                  value={SUBSCRIPTION_VARIANT.ALL}
                >
                 {exchange === EXCHANGE_MODES.NSE_BSE ? 'NSE All F&O + BSE Index' : 'All F&O'}{variant === SUBSCRIPTION_VARIANT.ALL ? <ShadowedTickIcon/> : ''} <br/>(11,000+ instruments)
                </Radio.Button>
              </Radio.Group>
            </Box>
          </>
        )}
        
        {/* Region Toggle */}
        {exchange === EXCHANGE_MODES.NSE && (<Box sx={{
          mt: 3, 
          mb: 1,
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: 2,
          '& .ant-radio-button-wrapper::before': {
            display: 'none !important',
            width: '0 !important',
            backgroundColor: 'transparent !important'
          },
          '& .ant-radio-button-wrapper:not(:first-child)::before': {
            display: 'none !important',
            width: '0 !important'
          }
        }}>
          <Typography sx={{
            fontSize:"12px", 
            color: COLORS.textSecondary, 
            textTransform: 'uppercase', 
            letterSpacing: '1.2px',
            fontWeight: 600,
            minWidth: '55px'
          }}>
            Region:
          </Typography>
          <Radio.Group
            buttonStyle="solid"
            value={isInternational ? 'international' : 'domestic'}
            onChange={(e)=>{
              const isIntl = e.target.value === 'international';
              setIsInternational(isIntl);
              setIsInternationalPremium(isIntl);
              setIsInternationalElite(isIntl);
            }}
            size="small"
            style={{display:'flex', gap: '8px'}}
          >
            <Radio.Button
              style={{
                fontSize:"14px",
                textAlign:'center',
                color: !isInternational ? '#FFFFFF' : COLORS.textSecondary,
                background: !isInternational 
                  ? 'linear-gradient(135deg, #10B981, #059669)' 
                  : 'rgba(16, 185, 129, 0.1)',
                height: "38px",
                lineHeight: "38px",
                paddingLeft: "20px",
                paddingRight: "20px",
                fontWeight: !isInternational ? 600 : 500,
                borderRadius: '8px',
                transition: 'all 0.3s ease',
                boxShadow: !isInternational 
                  ? '0 4px 12px rgba(16, 185, 129, 0.3)' 
                  : 'none',
                border: !isInternational 
                  ? '2px solid #10B981' 
                  : 'none',
              }}
              value="domestic"
            >
              🇮🇳 Domestic
            </Radio.Button>
            <Radio.Button
              style={{
                fontSize:"13px",
                textAlign:'center',
                color: isInternational ? '#FFFFFF' : COLORS.textSecondary,
                background: isInternational 
                  ? `linear-gradient(135deg, ${COLORS.primaryBlue}, ${COLORS.accentPurple})` 
                  : 'rgba(157, 106, 248, 0.1)',
                height: "38px",
                lineHeight: "38px",
                paddingLeft: "20px",
                paddingRight: "20px",
                fontWeight: isInternational ? 600 : 500,
                borderRadius: '8px',
                transition: 'all 0.3s ease',
                boxShadow: isInternational 
                  ? '0 4px 12px rgba(157, 106, 248, 0.34)' 
                  : 'none',
                border: isInternational 
                  ? `2px solid ${COLORS.accentPurple}` 
                  : 'none',
              }}
              value="international"
            >
              🌍 International
            </Radio.Button>
          </Radio.Group>
        </Box>
        )}
        </Box>
      
      {/* <Typography  sx={{mb:0,mt:2,textAlign:'center',fontSize:"26px",fontWeight:600,color:'#FBE103'}}>We celebrate India's Cricket World Cup victory by extending Diwali Offer by 1 additional day</Typography>
      <Typography  sx={{mb:1,textAlign:'center',fontSize:"26px",fontWeight:600,color:'#FBE103'}}>Top it up with an Additional 10% Discount across all Plans - Use Discount code: <u>INDIACRICKETCHAMP</u></Typography> */}
      {/* <Typography  sx={{mb:0,mt:2,textAlign:'center',fontSize:"28px",fontWeight:600,color:'#FBE103'}}>Chart your path to data-driven trading in 2024! <br/>Subscribe to our Annual Plans and enjoy an additional 30% discount with Coupon Code: <u>HNY2024</u>. <br/>Wishing you a happy new year and many more filled with financial achievements! <br/>Offer starts from 29th December and is valid till 7th January 2024.</Typography> */}
      {/* <Typography  sx={{mb:0,mt:2,textAlign:'center',fontSize:"28px",fontWeight:600,color:'#F3B23E'}}>Stay tuned for our upcoming exciting new year discount offer on Annual Plans..</Typography> */}
      {/* <Typography  sx={{mb:0,mt:2,textAlign:'center',fontSize:"25px",fontWeight:600,color:'#FBE103'}}>Save 5% with a Quarterly plan, 10% with a Half-yearly plan and Save 20% when you subscribe for an Annual plan</Typography> */}
      {/* <Typography  sx={{mb:1,textAlign:'center',fontSize:"24px",fontWeight:600,color:'#FBE103'}}>BONUS: Get Market Profile and Orderflow <Link href='https://vtrender.com/ecourse/' target='_blank' sx={{mb:1,textAlign:'center',fontSize:"24px",fontWeight:600,color:'#FBE103',cursor:"pointer"}} variant="link">ECourse</Link> Unlimited Access along with Annual Subscription of any Orderflow plan.. FREE!</Typography> */}
      {exchange === EXCHANGE_MODES.NSE && (
        <>
          <br/>
          <Box sx={{
            mt: 2,
            mb: 3,
            display: 'flex',
            justifyContent: 'center',
            px: 2
          }}>
            <Box sx={{
              maxWidth: '900px',
              width: '100%',
              backgroundColor: 'rgba(251, 225, 3, 0.08)',
              borderRadius: 2,
              border: `1px solid rgba(251, 225, 3, 0.3)`,
              padding: 2.5,
              transition: 'all 0.2s ease',
              "&:hover": {
                backgroundColor: 'rgba(251, 225, 3, 0.12)',
              }
            }}>
              <Typography sx={{
                textAlign: 'center',
                fontSize: "17px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6
              }}>
                <strong style={{ color: '#FBE103', fontWeight: 600 }}>BONUS:</strong>
                &nbsp;Get the Market Profile and Orderflow Trading Strategies ECourse - Unlimited Access - worth&nbsp;
                <strong style={{ color: '#FBE103' }}><RupeeSymbol />3539</strong>, along with an&nbsp;
                <u style={{ color: COLORS.textPrimary }}>Annual Subscription</u> of any plan.. <strong style={{ color: '#40B66E' }}>FREE!</strong>
              </Typography>
            </Box>
          </Box>
          <Box sx={{
            mt: -0.5,
            mb: 3,
            display: 'flex',
            justifyContent: 'center',
            px: 2,
            width: '100%',
          }}>
            {shouldShowBseTab && <Box sx={{
              maxWidth: '900px',
              width: '100%',
              minHeight: '108px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              borderRadius: '12px',
              border: '1px solid rgba(164, 112, 255, 0.95)',
              background: 'linear-gradient(180deg, rgba(35, 20, 66, 0.96), rgba(23, 14, 45, 0.96))',
              boxShadow: 'inset 0 1px 0 rgba(207, 180, 255, 0.09)',
              px: 2.5,
              py: 2.1,
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.4, flexWrap: 'wrap' }}>
                <Box sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  px: 1.2,
                  py: 0.3,
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.5px',
                  color: '#F5EEFF',
                  background: 'linear-gradient(180deg, #B08CFF 0%, #8E63F6 100%)',
                }}>
                  NEW
                </Box>
                <Typography sx={{ fontSize: { xs: '14px', md: '17px' }, fontWeight: 700, color: '#F4F1FF', lineHeight: 1.25 }}>
                  BSE Data Add-on now available for Professional & Elite subscribers
                </Typography>
              </Box>
              <Typography sx={{ mt: 0.45, textAlign: 'center', fontSize: { xs: '13px', md: '16px' }, fontWeight: 500, color: '#FFFFFF', lineHeight: 1.3 }}>
                Add Sensex, Bankex Options & Futures to your existing plan
              </Typography>
              <Typography sx={{ mt: 0.45, textAlign: 'center', fontSize: { xs: '13px', md: '16px' }, fontWeight: 600, color: '#A573FF', lineHeight: 1.25 }}>
                + <RupeeSymbol />{bseTopUpBannerMonthlyPrice} / month, Inclusive of GST and BSE PUC charges
              </Typography>
            </Box>}
          </Box>
        </>
      )}

      {/* <Typography  sx={{mb:0,mt:2,textAlign:'center',fontSize:"28px",fontWeight:600,color:'#FBE103'}}>Exciting Diwali Offers! <br/>Subscribe fast to take advantage of our limited-time discount on annual plans and lock-in the lowest price available!</Typography>
      <Typography  sx={{mb:1,mt:2,textAlign:'center',fontSize:"26px",fontWeight:600,color:'#FBE103'}}>Get a Flat 40% Discount on any Annual plan.</Typography>
      <Typography  sx={{mb:2,textAlign:'center',fontSize:"24px",fontWeight:600,color:'#FBE103'}}>Get Flat 10% Discount on any Half-yearly plan</Typography>
      <Typography  sx={{mb:1,textAlign:'center',fontSize:"24px",fontWeight:600,color:'#FBE103'}}>BONUS: Get MP and Orderflow <Link href='https://vtrender.com/ecourse/' target='_blank' sx={{mb:1,textAlign:'center',fontSize:"24px",fontWeight:600,color:'#FBE103',cursor:"pointer"}} variant="link">ECourse</Link> Unlimited Access along with Orderflow Annual Subscription FREE!</Typography> */}

        {!isError && !isErrorUserSubs?  
        <>
        {isBseAddOnSelected ? (
          <Box sx={{ mt: 4, px: 2, width: '100%', maxWidth: '1180px', mx: 'auto' }}>
            {bseAddOnCards.length === 0 ? (
              <Box sx={{
                p: 3,
                textAlign: 'center',
                borderRadius: 2,
                backgroundColor: 'rgba(242, 160, 96, 0.1)',
                border: '1px solid rgba(242, 160, 96, 0.35)'
              }}>
                <Typography sx={{ color: COLORS.eliteOrange, fontSize: '14px', fontWeight: 600 }}>
                  {auth?.accessToken
                    ? "No active NSE Professional/Elite subscription found for Add-on."
                    : "BSE Add-on pricing is currently unavailable. Please try again in some time."}
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={3} justifyContent="center">
                {bseAddOnCards.map((card) => {
                  const tier = card.tierData || {};
                  const termPeriod = tier.period || 1;
                  const baseAmount = Number(tier.base) || 0;
                  const gstComponent = Number(tier.base_gst) || 0;
                  const totalAmount = Math.floor(monthlyDiscFactor * (baseAmount + gstComponent));
                  const actualAmount = Number(tier.base_actual) || totalAmount;
                  const hasDiscount = actualAmount > totalAmount;
                  const showProRataTag = card.term === BSE_TOP_UP_TERM.FLEX;
                  const isFlexCard = card.term === BSE_TOP_UP_TERM.FLEX;
                  const isMonthlyCard = card.term === BSE_TOP_UP_TERM.MONTHLY;
                  const isEliteCard = card.key === "elite";
                  const accentStart = isFlexCard
                    ? COLORS.proRataWarm
                    : (isEliteCard ? COLORS.eliteOrange : COLORS.primaryBlue);
                  const accentEnd = isFlexCard ? COLORS.proRataRose : COLORS.accentPurple;
                  const glowColor = isFlexCard
                    ? "rgba(255, 180, 110, 0.26)"
                    : (isEliteCard ? "rgba(242, 160, 96, 0.22)" : "rgba(54, 194, 180, 0.24)");
                  // Slight tone split between 1 Month and Pro Rata cards for quicker scanability.
                  const cardBackground = isFlexCard
                    ? "radial-gradient(circle at 82% 0%, rgba(255, 180, 110, 0.24), transparent 44%), linear-gradient(160deg, rgba(46, 26, 27, 0.97), rgba(28, 16, 26, 0.96))"
                    : (isEliteCard
                      ? "radial-gradient(circle at 18% 0%, rgba(157, 106, 248, 0.16), transparent 40%), linear-gradient(160deg, rgba(24, 37, 57, 0.95), rgba(18, 30, 49, 0.92))"
                      : "radial-gradient(circle at 20% 0%, rgba(157, 106, 248, 0.14), transparent 40%), linear-gradient(160deg, rgba(17, 32, 56, 0.95), rgba(14, 27, 46, 0.92))");
                  const termBorder = isFlexCard
                    ? '2px solid rgba(255, 180, 110, 0.95)'
                    : (isEliteCard ? '2px solid rgba(242, 160, 96, 0.76)' : '2px solid rgba(54, 194, 180, 0.76)');
                  const termShadow = isFlexCard
                    ? '0 14px 40px rgba(255, 180, 110, 0.28), inset 0 1px 0 rgba(255,255,255,0.08)'
                    : `0 12px 34px ${glowColor}, inset 0 1px 0 rgba(255,255,255,0.06)`;

                  return (
                    <Grid item xs={12} md={6} key={`${card.key}-${card.term}`} sx={{ display: 'flex' }}>
                      <Card sx={{
                        width: '100%',
                        minHeight: 460,
                        p: 2.5,
                        borderRadius: 4,
                        background: cardBackground,
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)',
                        border: termBorder,
                        boxShadow: termShadow,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        position: 'relative',
                        transition: 'all 0.3s ease',
                        "&::before": {
                          content: '""',
                          position: 'absolute',
                          inset: 0,
                          background: "linear-gradient(135deg, rgba(255,255,255,0.06), transparent 34%, transparent 70%, rgba(255,255,255,0.04))",
                          pointerEvents: 'none'
                        },
                        "&:hover": {
                          transform: 'translateY(-4px)',
                          borderColor: isFlexCard
                            ? 'rgba(255, 180, 110, 1)'
                            : (isEliteCard ? 'rgba(242, 160, 96, 0.95)' : 'rgba(54, 194, 180, 0.95)'),
                          boxShadow: isFlexCard
                            ? '0 20px 46px rgba(255, 180, 110, 0.34)'
                            : `0 18px 44px ${glowColor}`
                        }
                      }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 0.5 }}>
                          <Typography sx={{
                            textAlign: 'center',
                            fontSize: '26px',
                            fontWeight: 700,
                            background: `linear-gradient(135deg, ${accentStart}, ${accentEnd})`,
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            color: 'transparent',
                            textShadow: isEliteCard
                              ? '0 1px 10px rgba(242, 160, 96, 0.2)'
                              : '0 1px 10px rgba(54, 194, 180, 0.22)'
                          }}>
                            BSE Data Add-on
                          </Typography>
                        </Box>

                        <Typography sx={{
                          textAlign: 'center',
                          fontSize: '13px',
                          fontWeight: 600,
                          color: isFlexCard ? COLORS.proRataWarm : 'rgba(226, 232, 240, 0.78)',
                          mb: 1.2,
                          px: 1.4,
                          py: 0.45,
                          width: 'fit-content',
                          mx: 'auto',
                          borderRadius: '999px',
                          backgroundColor: isFlexCard ? 'rgba(255, 180, 110, 0.16)' : 'rgba(151, 166, 186, 0.12)',
                          border: isFlexCard ? '1px solid rgba(255, 180, 110, 0.62)' : '1px solid rgba(151, 166, 186, 0.34)',
                          boxShadow: isMonthlyCard ? '0 4px 12px rgba(15, 23, 42, 0.2)' : '0 6px 14px rgba(255, 180, 110, 0.24)'
                        }}>
                          {card.termLabel}
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                          {showProRataTag ? (
                            <Typography sx={{
                              textAlign: 'center',
                              fontSize: '36px',
                              mb: '8px',
                              mt: '8px',
                              fontWeight: 700,
                              color: isFlexCard ? COLORS.proRataWarm : (isEliteCard ? COLORS.eliteOrange : COLORS.primaryBlue),
                              letterSpacing: '0.4px',
                              textTransform: 'uppercase'
                            }}>
                              Pro Rata*
                            </Typography>
                          ) : (
                            <>
                              <Typography sx={{
                                textAlign: 'center',
                                fontSize: '44px',
                                fontWeight: 700,
                                background: `linear-gradient(135deg, ${accentStart}, ${accentEnd})`,
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                color: 'transparent',
                                filter: isEliteCard
                                  ? 'drop-shadow(0 2px 8px rgba(242, 160, 96, 0.2))'
                                  : 'drop-shadow(0 2px 8px rgba(54, 194, 180, 0.22))'
                              }}>
                                <RupeeSymbol />{totalAmount}
                              </Typography>
                              {hasDiscount && (
                                <Typography sx={{
                                  mt: 1.2,
                                  fontSize: '22px',
                                  color: COLORS.textSecondary,
                                  textDecoration: 'line-through',
                                  opacity: 0.6
                                }}>
                                  <RupeeSymbol />{actualAmount}
                                </Typography>
                              )}
                            </>
                          )}
                        </Box>

                        <PricingBreakdown
                          basePrice={baseAmount - ((bseFnoPuc ?? 0) * termPeriod)}
                          pucAmount={bseFnoPuc ?? 0}
                          pucPeriod={termPeriod}
                          pucLabel={"BSE PUC "}
                          gstAmount={Math.floor(monthlyDiscFactor * gstComponent)}
                          isInternational={false}
                          showDomesticBadge={false}
                          monthlyDiscText={monthlyDiscTxt}
                          glowColor={isFlexCard ? COLORS.proRataWarm : (isEliteCard ? COLORS.eliteOrange : COLORS.primaryBlue)}
                          colorTheme={isFlexCard ? "orange" : (isEliteCard ? "orange" : "blue")}
                          basePriceLabelSuffix={showProRataTag ? " (Pro Rata*)" : ""}
                          basePriceValueLabel={showProRataTag ? "Pro Rata*" : ""}
                          pucValueLabel={showProRataTag ? `₹${(bseFnoPuc ?? 0) * termPeriod} ` : ""}
                          gstValueLabel={showProRataTag ? "18%" : undefined}
                          containerWidth="100%"
                        />

                        <Box sx={{ width: '100%', mt: 1.5 }}>
                          <Typography sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: isEliteCard ? COLORS.eliteOrange : COLORS.primaryBlue,
                            mb: 1.2,
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            📡 &nbsp;Data Access&nbsp;<BSELogo />
                          </Typography>
                          <FeatureItem
                            icon={<CheckIcon sx={{ color: COLORS.success }} />}
                            text="Get real-time data feed"
                            highlight={true}
                          />
                          <FeatureItem
                            icon={<CheckIcon sx={{ color: COLORS.success }} />}
                            text="BSE Index instruments coverage"
                          />
                          <FeatureItem
                            icon={<CheckIcon sx={{ color: COLORS.success }} />}
                            text="Stable low-latency updates"
                          />
                          <FeatureItem
                            icon={<CheckIcon sx={{ color: COLORS.success }} />}
                            text="Actionable market snapshots"
                          />
                        </Box>

                        <Box sx={{ flexGrow: 1 }} />
                        <Button
                          sx={{
                            ...modernButtonSX,
                            width: '100%',
                            maxWidth: '320px',
                            alignSelf: 'center',
                            borderRadius: '12px',
                            letterSpacing: '0.3px',
                            background: isEliteCard
                              ? (isFlexCard
                                ? `linear-gradient(135deg, ${COLORS.proRataWarm}, ${COLORS.proRataRose})`
                                : `linear-gradient(135deg, ${COLORS.eliteOrangeDark}, ${COLORS.accentPurpleDark})`)
                              : (isFlexCard
                                ? `linear-gradient(135deg, ${COLORS.proRataWarm}, ${COLORS.proRataRose})`
                                : `linear-gradient(135deg, #2FAE9F, ${COLORS.accentPurpleDark})`),
                            boxShadow: isEliteCard
                              ? (isFlexCard ? '0 10px 22px rgba(255, 180, 110, 0.34)' : '0 10px 22px rgba(242, 160, 96, 0.34)')
                              : isFlexCard
                                ? '0 10px 22px rgba(255, 180, 110, 0.34)'
                                : '0 10px 22px rgba(157, 106, 248, 0.34)',
                            "&:hover": {
                              transform: 'translateY(-1px)',
                              background: isEliteCard
                                ? (isFlexCard
                                  ? `linear-gradient(135deg, ${COLORS.proRataWarmDark}, ${COLORS.proRataRoseDark})`
                                  : `linear-gradient(135deg, ${COLORS.eliteOrangeDark}, ${COLORS.accentPurpleDark})`)
                                : (isFlexCard
                                  ? `linear-gradient(135deg, ${COLORS.proRataWarmDark}, ${COLORS.proRataRoseDark})`
                                  : `linear-gradient(135deg, #279D90, ${COLORS.accentPurpleDark})`)
                            }
                          }}
                          onClick={() =>
                            handleClick(
                              card.planType,
                              true,
                              false,
                              card.term === BSE_TOP_UP_TERM.FLEX ? card.term : undefined
                            )
                          }
                        >
                          {card.actionLabel}
                        </Button>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>
        ) : (
        <>
        {/* NEW: 3-column grid for Free + Premium + Elite */}
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 4, px: 2, maxWidth: '1800px', mx: 'auto' }}>
          {/* FREE TIER */}
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ display: 'flex' }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <Card variant="outlined" sx={modernCardSX}>
                <Typography sx={{mb:2,mt:2,textAlign:'center',fontSize:"32px",fontWeight:700,color:COLORS.textPrimary}}>
                  Free
                </Typography>
                <Typography sx={{mb:0,mt:1,textAlign:'center',fontSize:"48px",fontWeight:700,color:COLORS.textPrimary}}>
                  <RupeeSymbol />0
                </Typography>
                <Typography sx={{mb:3,mt:1,textAlign:'center',fontSize:"14px",color:COLORS.textSecondary}}>
                  Forever Free
                </Typography>
                
                {/* Feature list - EXACT PREMIUM TIER FEATURES from subscription.js */}
                <Box sx={{width: '100%', mt: 18}}>
                  {/* Data Quality */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 2, display: 'flex', alignItems: 'center'}}>
                    📡 &nbsp;Data Access
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Delayed data (15 minutes delay)"
                    tooltip="Market data delayed by minimum 15 minutes"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Limited set of instruments"
                    tooltip="Actively Traded Futures and Options instruments of Nifty and BankNifty instruments only"
                    highlight={true}
                  />
                  
                  {/* Core Charts & Analysis */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 4}}>
                    📊 &nbsp;Core Charts & Analysis
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="MP Charts, Options Table, Greeks Table and Indices Table for Index instruments"
                    tooltip="Complete market analysis tools for major indices"
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Historical MP Charts in different timeframes for higher timeframe market analysis"
                    tooltip="Historical data analysis across multiple timeframes in Market Profile charts"
                  />
                  {/* <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Unique short timeframe Candlestick and Line Charts for NF/BNF/FNF FnO instruments"
                    tooltip="Short-term chart analysis for FnO instruments"
                  /> */}

                  {/* Advanced Analysis Tools */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 4}}>
                    🔬 &nbsp;Advanced Analysis Tools
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Advanced OI, IV Curves, Synthetic futures and other market data Visualization Charts"
                    tooltip="Comprehensive market data visualization tools using generally available OI and IV data. OI Snakes, IV distribution curves, Strike wise OI bars and normal Gamma positioning of market."
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="All options combined OI Change and Volume charts"
                    tooltip="Track all options combined open interest and volume analysis to observe changing market momentum"
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Historical Volatility charts"
                    tooltip="Long timeframe historical volatility analysis charts with all types of statistical plots to understand the current market regime for Nifty and BankNifty indices. Different data points analysed are: ATR trend, Close to Close, Close to Open, Gaps data statistics, Traded Day Range stats etc."
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Instruments Payoff analysis and future price projection charts"
                    tooltip="Payoff analysis and price projection tools"
                  />

                  {/* Participant positions */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 4}}>
                    🎯 &nbsp;Participant Positions Analysis
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Participant wise FnO positions and changes"
                    tooltip="Positioning changes of different participants - FIIs, Clients, Pros and DIIs"
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="FII Data"
                    tooltip="Special dedicated page for showing FII postion changes and breakup of their positions in NF and BNF"
                  />

                  {/* Trading Features */}
                  {/* <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 2}}>
                    🎯 &nbsp;Trading Features
                  </Typography> */}
                  {/* <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Auto-Generated KRLs for NF/BNF and Custom KRLs on MP Charts"
                    tooltip="Key Reference Levels for trading"
                  /> */}
                  {/* <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Useful Tooltips on Market Profile charts that also show some additional information for important references"
                    tooltip="Enhanced chart information and tooltips"
                  /> */}

                  {/* Productivity Tools */}
                  {/* <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 2}}>
                    ⚡ Productivity Tools
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Auto/Manual Saving supported across all instruments in MP charts"
                    tooltip="Save your chart configurations across all instruments"
                  /> */}
                
              </Box>
              
                <Box sx={{ flexGrow: 1 }} /> {/* Spacer to push button to bottom */}
                <Button sx={{
                  ...modernButtonSX,
                  background: 'transparent',
                  border: `1px solid ${COLORS.borderLight}`,
                  color: COLORS.textPrimary,
                  boxShadow: 'none',
                  "&:hover": {
                    background: 'rgba(151, 166, 186, 0.08)',
                    borderColor: COLORS.borderHover,
                    boxShadow: 'none',
                    transform: 'translateY(-1px)',
                  }
                }} onClick={() => navigate(auth?.accessToken ? '/' : '/register')}>
                  Get Started Free
                </Button>
            </Card>
            </motion.div>
          </Grid>
          
          {/* PREMIUM TIER (old Expert) */}
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ display: 'flex' }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.15 }}
            >
              <Card variant="outlined" sx={premiumCardSX}>
                {/* Featured badge - PROPERLY POSITIONED INSIDE CARD */}
                <Box sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  background: `linear-gradient(135deg, ${COLORS.primaryBlue}, ${COLORS.accentPurple})`,
                  color: COLORS.textPrimary,
                  padding: '4px 12px',
                  borderRadius: 16,
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  boxShadow: '0 4px 12px rgba(157, 106, 248, 0.35)',
                  border: `1px solid rgba(255, 255, 255, 0.2)`,
                  zIndex: 10,
                  letterSpacing: '0.3px',
                }}>
                  LIVE-DATA
        </Box>
                
                <Typography sx={{mb:2,mt:2,textAlign:'center',fontSize:"32px",fontWeight:700,color:COLORS.primaryBlue}}>
                  Professional
                </Typography>
                <Typography sx={{mb:0,mt:0,textAlign:'center',fontSize:"16px",color:COLORS.textSecondary,fontWeight:600}}>
                  {isBseAddOnSelected ? 'BSE Add-on' : (variant===SUBSCRIPTION_VARIANT.ALL? 'All F&O' : 'Index-only')}
                </Typography>
                
                {/* Use existing professionalTotal or expert pricing logic */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <Typography sx={{mb:0,mt:1,textAlign:'center',fontSize:"48px",fontWeight:700,color:COLORS.primaryBlue}}>
                    <RupeeSymbol />{isInternationalPremium 
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal_i : professionalIndexTotal_i)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal : professionalIndexTotal)}
                  </Typography>
                  
                  {/* Show strikethrough original price if there's a discount */}
                  {(() => {
                    const currentPrice = isInternationalPremium 
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal_i : professionalIndexTotal_i)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal : professionalIndexTotal);
                    const actualPrice = isInternationalPremium
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal_i_Actual : professionalIndexTotal_i_Actual)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotalActual : professionalIndexTotalActual);
                    const hasDiscount = actualPrice > currentPrice;
                    
                    return hasDiscount ? (
                      <Typography sx={{
                        mb:0, mt:2, ml:1, textAlign:'center', fontSize:"24px", fontWeight:500, 
                        color:COLORS.textSecondary,
                        textDecoration: 'line-through',
                        opacity: 0.6
                      }}>
                        <RupeeSymbol />{actualPrice}
                      </Typography>
                    ) : null;
                  })()}
                </Box>
                {renderBillingSavings(
                  isInternationalPremium
                    ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal_i : professionalIndexTotal_i)
                    : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal : professionalIndexTotal),
                  isInternationalPremium
                    ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal_i_Actual : professionalIndexTotal_i_Actual)
                    : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotalActual : professionalIndexTotalActual)
                )}
                
                <Typography sx={{mb:1,mt:0.5,textAlign:'center',fontSize:"12px",color:COLORS.textSecondary,opacity:0.7}}>
                  {typeText}
                </Typography>

                {period > 1 && (
                  <Typography sx={{
                    mt: 1,
                    mb: 0.5,
                    textAlign: 'center',
                    fontSize: '18px',
                    color: COLORS.primaryBlue,
                    opacity: 0.8,
                    fontStyle: 'italic'
                  }}>
                    <RupeeSymbol />{Math.floor((isInternationalPremium 
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal_i : professionalIndexTotal_i)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalTotal : professionalIndexTotal)) / period)} per Month
                  </Typography>
                )}
                
                {/* Pricing Breakdown - Tree Structure */}
                {(() => {
                  if (isBseAddOnSelected) {
                    const addOnProfessional = SUBSCRIPTION_PLANS_PRICE_NSE?.[type]?.[EXCHANGE_MODES.BSE_TOP_UP]?.professional;
                    if (!addOnProfessional) return null;
                    const bsePucValue = bseFnoPuc ?? 0;
                    return (
                      <PricingBreakdown
                        basePrice={addOnProfessional.base - bsePucValue}
                        pucAmount={bsePucValue}
                        pucPeriod={1}
                        pucLabel="BSE PUC"
                        gstAmount={Math.floor(monthlyDiscFactor * addOnProfessional.base_gst)}
                        isInternational={false}
                        showDomesticBadge={false}
                        monthlyDiscText={monthlyDiscTxt}
                        glowColor={COLORS.primaryBlue}
                      />
                    );
                  }

                  const pucValue = isInternationalPremium
                    ? nsePucInternational
                    : (exchange === EXCHANGE_MODES.NSE
                      ? nsePucDomestic
                      : ((nsePucDomestic ?? 0) + (bseFnoPuc ?? 0)));
                  const currentPeriod = SUBSCRIPTION_PLANS_PRICE_NSE?.[type]?.[exchange];
                  
                  if (typeof pucValue === "undefined" || !currentPeriod || !currentPeriod.professional) return null;
                  
                  const isStocksVariant = variant === SUBSCRIPTION_VARIANT.ALL;
                  const basePrice = isStocksVariant 
                    ? (isInternationalPremium ? currentPeriod.professional.stocks_i : currentPeriod.professional.stocks)
                    : (isInternationalPremium ? currentPeriod.professional.base_i : currentPeriod.professional.base);
                  const gstPrice = isStocksVariant
                    ? (isInternationalPremium ? currentPeriod.professional.stocks_gst_i : currentPeriod.professional.stocks_gst)
                    : (isInternationalPremium ? currentPeriod.professional.base_gst_i : currentPeriod.professional.base_gst);
                  
                  return (
                    <PricingBreakdown 
                      basePrice={basePrice - (pucValue * period)}
                      pucAmount={pucValue}
                      pucPeriod={period}
                      pucLabel={exchange === EXCHANGE_MODES.NSE_BSE ? 'NSE + BSE PUC' : undefined}
                      gstAmount={Math.floor(monthlyDiscFactor * gstPrice)}
                      isInternational={isInternationalPremium}
                      showDomesticBadge={exchange === EXCHANGE_MODES.NSE}
                      monthlyDiscText={monthlyDiscTxt}
                    />
                  );
                })()}
                
                {/* Feature list - Everything in Free + Premium features organized */}
                <Box sx={{width: '100%', mt: 2}}>
                  {/*Animated border*/}
                  <Box sx={{
                    position: 'relative',
                    padding: 1.5,
                    mb: 2,
                    borderRadius: 2,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      borderRadius: 2,
                      padding: '1.2px',
                      background: 'linear-gradient(90deg, transparent, rgba(54, 194, 180, 0.62), transparent)',
                      backgroundSize: '200% 100%',
                      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                      WebkitMaskComposite: 'xor',
                      maskComposite: 'exclude',
                      animation: 'borderAnimation 3s linear infinite',
                      pointerEvents: 'none'
                    },
                    '@keyframes borderAnimation': {
                      '0%': {
                        backgroundPosition: '200% 0'
                      },
                      '100%': {
                        backgroundPosition: '-200% 0'
                      }
                    }
                  }}>
                    <FeatureItem 
                      icon={<CheckIcon sx={{color: COLORS.primaryBlue, fontSize: 20}} />}
                      text="Everything in Free tier, with Live Data"
                      tooltip="All features from the Free tier work with live data and advanced additional functionalities"
                      highlight={true}
                    />
                  </Box>

                  {/* Data Quality & Speed */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 2, display: 'flex', alignItems: 'center'}}>
                    📡 &nbsp;Data Access&nbsp;<NSELogo />{exchange !== EXCHANGE_MODES.NSE && <BSELogo />}
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Live tick feed"
                    tooltip="Real-time data feed directly from NSE servers"
                    highlight={true}
                  />
                    {exchange === EXCHANGE_MODES.NSE_BSE && variant === SUBSCRIPTION_VARIANT.ALL && (
                      <FeatureItem 
                        icon={<CheckIcon sx={{color: COLORS.success}} />}
                        text="Real-time precision feed off BSE servers"
                        tooltip="Direct connection to BSE - no broker or intermediary required"
                        highlight={true}
                      />
                    )}
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Real-time precision feed off NSE servers"
                    tooltip="Direct connection to NSE - no broker or intermediary required"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text={variant===SUBSCRIPTION_VARIANT.ALL? 'All F&O instruments of Index and Stocks' : 'Index-only F&O instruments'}
                    tooltip={variant===SUBSCRIPTION_VARIANT.ALL? 'All actively traded F&O instruments of Index and Stocks available on Market Profile, Orderflow and Smart Candlestick™ charts' : 'All actively traded Index F&O instruments available on Market Profile, Orderflow and Smart Candlestick™ charts'}
                    highlight={true}
                  />

                  {/* Premium Proprietary Charts */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 2}}>
                    🎯 &nbsp;Premium Vtrender™ Charts (Index-only)
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text={<>NTM VolX<sup>™</sup> and NTM OI Change Charts</>}
                    tooltip="Advanced proprietary ananlysis of NTM volumes and NTM open interest data for Nifty and BankNifty"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Vtrender™ Spectrum Charts"
                    tooltip="Advanced proprietary options inventory positioning and intraday bias analysis tool for Nifty and BankNifty"
                    highlight={true}
                  />

                  {/* Advanced Trading Tools */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.primaryBlue, mb: 1.5, mt: 2}}>
                    🚀 &nbsp;Advanced Vtrender™ Tools and Features
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Useful Tooltips on Market Profile charts"
                    tooltip="Enhanced chart information and tooltips that show some additional information for important references"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Quick 10-minute previews of Orderflow data - Total 10 preview attempts each week."
                    tooltip="Access the Live Orderflow charts of any instrument for 10 mins. Total 10 attempts allowed every week. Make the best use of this feature to get additional help in making instant and dynamic decisions in instruments of interest."
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Custom & Anchored KRLs (Anchored VPOC / VWAP) on Market Profile Charts"
                    tooltip="Ability to mark custom KRLs and also anchored KRLs (Anchored , Anchored VWAP with 2SD lines) on MP Charts of all instruments."
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Custom and Sharable Market Profile Bookmarks and Bookmark specific KRLs"
                    tooltip="Advanced Market Profile specific bookmark system with custom and bookmark specific KRLs"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Auto-Generated KRLs for Nifty and BankNifty continuous futures charts"
                    tooltip="Useful Key Reference Levels for primary index futures - Nifty and BankNifty continuous futures chart."
                    highlight={true}
                  />
                  {/* <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Advanced OI, IV Curves, Synthetic futures and other market data Visualization Charts"
                    tooltip="Comprehensive market data visualization tools using generally available OI and IV data. Total Volumes, OI Snakes, IV distribution curves, Strike wise OI bars and normal Gamma positioning of market."
                    highlight={true}
                  /> */}
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Historical data comparison and analysis tools across all charts"
                    tooltip="Compare current data snapshot with old data at selected date / time in Options Table and all OI and Inventory Visualization Charts to analyze how data changed"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Multi-window chart view"
                    tooltip="View multiple charts simultaneously in same tab. Needs big screen device for optimal utilization. Supports upto 2x3 = 6 window view."
                    highlight={true}
                  />
                 </Box>
               
                <Box sx={{ flexGrow: 1 }} /> {/* Spacer to push button to bottom */}
                <Button
                  sx={modernButtonSX}
                  onClick={()=>handleClick(SUBSCRIPTION_PLAN_TYPE.PROFESSIONAL, variant===SUBSCRIPTION_VARIANT.INDEX, isInternationalPremium)}
                >
                  {isBseAddOnSelected ? 'Purchase (BSE Add-on)' : `Purchase (${variant===SUBSCRIPTION_VARIANT.ALL? 'All F&O' : 'Index-only'})`}
                </Button>
            </Card>
            </motion.div>
          </Grid>
          
          {/* ELITE TIER */}
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ display: 'flex' }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <Card variant="outlined" sx={{
                ...modernCardSX,
                border: `2px solid ${COLORS.eliteOrange}`,
                boxShadow: `0 10px 30px rgba(242, 160, 96, 0.24)`,
              }}>
                {/* Professional badge */}
                <Box sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  background: `linear-gradient(135deg, ${COLORS.eliteOrange}, ${COLORS.accentPurple})`,
                  color: COLORS.textPrimary,
                  padding: '4px 12px',
                  borderRadius: 16,
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  boxShadow: '0 4px 12px rgba(157, 106, 248, 0.36)',
                  border: `1px solid rgba(255, 255, 255, 0.2)`,
                  zIndex: 10,
                  letterSpacing: '0.3px',
                }}>
                  ORDERFLOW
                </Box>
               
                <Typography sx={{mb:2,mt:2,textAlign:'center',fontSize:"32px",fontWeight:700,color:COLORS.eliteOrange}}>
                  Elite
              </Typography>
                <Typography sx={{mb:0,mt:0,textAlign:'center',fontSize:"16px",color:COLORS.textSecondary,fontWeight:600}}>
                  {isBseAddOnSelected ? 'BSE Add-on' : (variant===SUBSCRIPTION_VARIANT.ALL? 'All F&O' : 'Index-only')}
                </Typography>
                
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <Typography sx={{mb:0,mt:1,textAlign:'center',fontSize:"48px",fontWeight:700,color:COLORS.eliteOrange}}>
                    <RupeeSymbol />{isInternationalElite 
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal_i : professionalOFIndexTotal_i)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal : professionalOFIndexTotal)}
                  </Typography>
                  
                  {/* Show strikethrough original price if there's a discount */}
                  {(() => {
                    const currentPrice = isInternationalElite 
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal_i : professionalOFIndexTotal_i)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal : professionalOFIndexTotal);
                    const actualPrice = isInternationalElite
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal_i_Actual : professionalOFIndexTotal_i_Actual)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotalActual : professionalOFIndexTotalActual);
                    const hasDiscount = actualPrice > currentPrice;
                    
                    return hasDiscount ? (
                      <Typography sx={{
                        mb:0, mt:2, ml:1, textAlign:'center', fontSize:"24px", fontWeight:500, 
                        color:COLORS.textSecondary,
                        textDecoration: 'line-through',
                        opacity: 0.6
                      }}>
                        <RupeeSymbol />{actualPrice}
                      </Typography>
                    ) : null;
                  })()}
                </Box>
                {renderBillingSavings(
                  isInternationalElite
                    ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal_i : professionalOFIndexTotal_i)
                    : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal : professionalOFIndexTotal),
                  isInternationalElite
                    ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal_i_Actual : professionalOFIndexTotal_i_Actual)
                    : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotalActual : professionalOFIndexTotalActual)
                )}
                
                <Typography sx={{mb:1,mt:0.5,textAlign:'center',fontSize:"12px",color:COLORS.textSecondary,opacity:0.7}}>
                  {typeText}
                </Typography>

                {period > 1 && (
                  <Typography sx={{
                    mt: 1,
                    mb: 0.5,
                    textAlign: 'center',
                    fontSize: '18px',
                    color: COLORS.eliteOrange,
                    opacity: 0.8,
                    fontStyle: 'italic'
                  }}>
                    <RupeeSymbol />{Math.floor((isInternationalElite 
                      ? (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal_i : professionalOFIndexTotal_i)
                      : (variant===SUBSCRIPTION_VARIANT.ALL ? professionalOFTotal : professionalOFIndexTotal)) / period)} per Month
                  </Typography>
                )}
                
                {/* Pricing Breakdown - Tree Structure */}
                {(() => {
                  if (isBseAddOnSelected) {
                    const addOnElite = SUBSCRIPTION_PLANS_PRICE_NSE?.[type]?.[EXCHANGE_MODES.BSE_TOP_UP]?.elite;
                    if (!addOnElite) return null;
                    const bsePucValue = bseFnoPuc ?? 0;
                    return (
                      <PricingBreakdown
                        basePrice={addOnElite.base - bsePucValue}
                        pucAmount={bsePucValue}
                        pucPeriod={1}
                        pucLabel="BSE PUC"
                        gstAmount={Math.floor(monthlyDiscFactor * addOnElite.base_gst)}
                        isInternational={false}
                        showDomesticBadge={false}
                        monthlyDiscText={monthlyDiscTxt}
                        glowColor={COLORS.eliteOrange}
                      />
                    );
                  }

                  const pucValue = isInternationalElite
                    ? nsePucInternational
                    : (exchange === EXCHANGE_MODES.NSE
                      ? nsePucDomestic
                      : ((nsePucDomestic ?? 0) + (bseFnoPuc ?? 0)));
                  const currentPeriod = SUBSCRIPTION_PLANS_PRICE_NSE?.[type]?.[exchange];
                  
                  if (typeof pucValue === "undefined" || !currentPeriod || !currentPeriod.elite) return null;
                  
                  const isStocksVariant = variant === SUBSCRIPTION_VARIANT.ALL;
                  const basePrice = isStocksVariant 
                    ? (isInternationalElite ? currentPeriod.elite.stocks_i : currentPeriod.elite.stocks)
                    : (isInternationalElite ? currentPeriod.elite.base_i : currentPeriod.elite.base);
                  const gstPrice = isStocksVariant
                    ? (isInternationalElite ? currentPeriod.elite.stocks_gst_i : currentPeriod.elite.stocks_gst)
                    : (isInternationalElite ? currentPeriod.elite.base_gst_i : currentPeriod.elite.base_gst);
                  
                  return (
                    <PricingBreakdown 
                      basePrice={basePrice - (pucValue * period)}
                      pucAmount={pucValue}
                      pucPeriod={period}
                      pucLabel={exchange === EXCHANGE_MODES.NSE_BSE ? 'NSE + BSE PUC' : undefined}
                      gstAmount={Math.floor(monthlyDiscFactor * gstPrice)}
                      isInternational={isInternationalElite}
                      showDomesticBadge={exchange === EXCHANGE_MODES.NSE}
                      monthlyDiscText={monthlyDiscTxt}
                      glowColor={COLORS.eliteOrange}
                    />
                  );
                })()}
                
                {/* Feature list - Everything in Free + Premium + Elite features */}
                <Box sx={{width: '100%', mt: 2}}>
                  {/*Animated border*/}
                  <Box sx={{
                    position: 'relative',
                    padding: 1.5,
                    mb: 2,
                    borderRadius: 2,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      borderRadius: 2,
                      padding: '1.2px',
                      background: 'linear-gradient(90deg, transparent, rgba(242, 160, 96, 0.62), transparent)',
                      backgroundSize: '200% 100%',
                      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                      WebkitMaskComposite: 'xor',
                      maskComposite: 'exclude',
                      animation: 'borderAnimation 3s linear infinite',
                      pointerEvents: 'none'
                    },
                    '@keyframes borderAnimation': {
                      '0%': {
                        backgroundPosition: '200% 0'
                      },
                      '100%': {
                        backgroundPosition: '-200% 0'
                      }
                    }
                  }}>
                    <FeatureItem 
                      icon={<CheckIcon sx={{color: COLORS.eliteOrange, fontSize: 21}} />}
                      text="Everything in Free and Professional tiers"
                      tooltip="All features from the Free tier work with live data and advanced additional functionalities"
                      highlight={true}
                    />
                  </Box>

                  {/* Data Access for Elite tier */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.eliteOrange, mb: 1.5, mt: 2}}>
                    📡 &nbsp;Data Access&nbsp;<NSELogo />{exchange !== EXCHANGE_MODES.NSE && <BSELogo />}
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Live tick feed"
                    tooltip="Real-time data feed directly from NSE servers"
                    highlight={true}
                  />
                    {exchange === EXCHANGE_MODES.NSE_BSE && variant === SUBSCRIPTION_VARIANT.ALL && (
                      <FeatureItem 
                        icon={<CheckIcon sx={{color: COLORS.success}} />}
                        text="Real-time precision feed off BSE servers"
                        tooltip="Direct connection to BSE - no broker or intermediary required"
                        highlight={true}
                      />
                    )}
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Real-time precision feed off NSE servers"
                    tooltip="Direct connection to NSE - no broker or intermediary required"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text={variant===SUBSCRIPTION_VARIANT.ALL? 'All F&O instruments of Index and Stocks' : 'Index-only F&O instruments'}
                    tooltip={variant===SUBSCRIPTION_VARIANT.ALL? 'All actively traded F&O instruments of Index and Stocks available on Market Profile, Orderflow and Smart Candlestick™ charts' : 'All actively traded Index F&O instruments available on Market Profile, Orderflow and Smart Candlestick™ charts'}
                    highlight={true}
                  />

                  {/* Elite-Exclusive: Orderflow Suite */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.eliteOrange, mb: 1.5, mt: 2}}>
                    ⭐ &nbsp;Elite Exclusive - Vtrender™ Orderflow Suite
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Orderflow Charts with proprietary IB/IS, LLT signals and real-time COT reading"
                    tooltip="Advanced order flow analysis with proprietary Imbalance/Impulse Signals and markers for Large Lot Traders along with Buyer and Seller imbalances and Bar wise VWAP/VPOC levels. Our proprietary COT calculations shows the bias and Commitment of Traders in real time."
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Unique Replay feature in Orderflow charts for an advanced post market analysis."
                    tooltip="Replay the Orderflow charts - at variable speeds - for a historical date to study and observe how price behaved on a given eventful date and how big players played the auction process throughout the day. Note: Historical date is limited to availability of data."
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text={<>Smart Candlestick<sup>™</sup> charts with Micro Balance<sup>™</sup> boxes and Realtime Orderflow signals</>}
                    tooltip="Advanced Candlestick analysis with proprietary balance/imbalance detection and Micro Balance™ boxes with different intensities. It also shows Real-time Orderflow signals and updates."
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text={<>MFlow<sup>™</sup> Indicator on Smart Candlestick<sup>™</sup> charts - proprietary momentum flow analysis</>}
                    tooltip="Exclusive momentum flow indicator for tracking market momentum shifts. A very useful tool for an options trader."
                    highlight={true}
                  />
                  
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.eliteOrange, mb: 1.5, mt: 2}}>
                    🎯 &nbsp;Premium Proprietary Charts (Index-only)
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Vtrender™ Gamma Density and Vtrender™ Exposure Charts"
                    tooltip="Advanced proprietary gamma based positioning analysis for options of Nifty and BankNifty"
                    highlight={true}
                  />
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="All Professional Proprietary Charts, Tools and Visualizations with advanced features"
                    tooltip="All features of Professional tier are included with additional advanced featues in few cases."
                    highlight={true}
                  />

                  {/* Enhanced Features */}
                  <Typography sx={{fontSize: "16px", fontWeight: 600, color: COLORS.eliteOrange, mb: 1.5, mt: 2}}>
                    🎨 &nbsp;Enhanced Visualization & Tools
                  </Typography>
                  <FeatureItem 
                    icon={<CheckIcon sx={{color: COLORS.success}} />}
                    text="Global Bookmarks for saving multi-window views with customizable settings and drawings"
                    tooltip="Advanced bookmark system for saving complex multi-window setups with full customization"
                    highlight={true}
                  />
        </Box>

                <Box sx={{ flexGrow: 1 }} /> {/* Spacer to push button to bottom */}
                <Button sx={{
                  ...modernButtonSX,
                  background: `linear-gradient(135deg, ${COLORS.eliteOrange}, ${COLORS.accentPurple})`,
                  "&:hover": {
                    background: `linear-gradient(135deg, ${COLORS.eliteOrangeDark}, ${COLORS.accentPurpleDark})`,
                    boxShadow: '0 6px 20px rgba(157, 106, 248, 0.42)',
                  }
                }} onClick={()=>handleClick(SUBSCRIPTION_PLAN_TYPE.ELITE, variant===SUBSCRIPTION_VARIANT.INDEX, isInternationalElite)}>
                  {isBseAddOnSelected ? 'Purchase (BSE Add-on)' : `Purchase (${variant===SUBSCRIPTION_VARIANT.ALL? 'All F&O' : 'Index-only'})`}
                </Button>
           </Card>
            </motion.div>
          </Grid>
        </Grid>
        </>
        )}

        <Box sx={{ mt: 8, mb: 1, px: 2, maxWidth: '900px', textAlign: 'center' }}>
          <Typography sx={{
            textAlign: 'center',
            color: COLORS.textPrimary,
            fontSize: '2.5rem',
            fontWeight: 700,
            lineHeight: 1.2
          }}>
            VLD Subscriptions
          </Typography>
          <Typography sx={{
            mt: 1.5,
            textAlign: 'center',
            color: COLORS.textSecondary,
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: 1.5
          }}>
            Each plan includes Vtrender Charts (Elite Plan - NSE only) along with the Live Desk environment.
          </Typography>
        </Box>
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 2, px: 2, maxWidth: '1800px', mx: 'auto' }}>
          {VLD_ORDERFLOW_PLANS.map((plan, index) => {
            const titleColor = plan.featured ? COLORS.primaryBlue : COLORS.textPrimary;
            const priceView = getVldPriceView(plan.periodKey);
            const displayPrice = priceView ? priceView.total : plan.fallbackPrice;
            return (
              <Grid item xs={4} sm={4} md={4} lg={4} xl={4} key={plan.id} sx={{ display: 'flex' }}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.15 }}
                  style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center' }}
                >
                  <Card
                    variant="outlined"
                    sx={plan.featured
                      ? { ...premiumCardSX, minHeight: 0, height: '100%' }
                      : { ...modernCardSX, minHeight: 0, height: '100%' }}
                  >
                    <Typography sx={{ mb: 2, mt: 2, textAlign: 'center', fontSize: '32px', fontWeight: 700, color: titleColor }}>
                      {plan.title}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                      <Typography sx={{ mb: 0, mt: 1, textAlign: 'center', fontSize: '48px', fontWeight: 700, color: titleColor }}>
                        <RupeeSymbol />{displayPrice.toLocaleString('en-IN')}
                      </Typography>
                      {priceView?.hasDiscount ? (
                        <Typography sx={{
                          mb: 0, mt: 2, ml: 1, textAlign: 'center', fontSize: '24px', fontWeight: 500,
                          color: COLORS.textSecondary,
                          textDecoration: 'line-through',
                          opacity: 0.6
                        }}>
                          <RupeeSymbol />{priceView.actual.toLocaleString('en-IN')}
                        </Typography>
                      ) : null}
                    </Box>
                    {priceView?.savings && plan.saveSuffix ? (
                      <Typography sx={{ mb: 0, mt: '-4px', textAlign: 'center', fontSize: '14px', fontWeight: 600, color: COLORS.success, lineHeight: 1.2 }}>
                        Save <RupeeSymbol />{priceView.savings.toLocaleString('en-IN')}{plan.saveSuffix}
                      </Typography>
                    ) : null}
                    <Typography sx={{ mb: 1, mt: 0.5, textAlign: 'center', fontSize: '12px', color: COLORS.textSecondary, opacity: 0.7 }}>
                      {plan.billingLabel}
                    </Typography>
                    {priceView?.perMonth ? (
                      <Typography sx={{
                        mt: 1,
                        mb: 0.5,
                        textAlign: 'center',
                        fontSize: '18px',
                        color: titleColor,
                        opacity: 0.8,
                        fontStyle: 'italic'
                      }}>
                        <RupeeSymbol />{priceView.perMonth.toLocaleString('en-IN')} per Month
                      </Typography>
                    ) : null}
                    {priceView ? (
                      <PricingBreakdown
                        basePrice={priceView.basePrice}
                        pucAmount={priceView.pucAmount}
                        pucPeriod={priceView.pucPeriod}
                        gstAmount={priceView.gstAmount}
                        isInternational={false}
                        showDomesticBadge={true}
                        monthlyDiscText={monthlyDiscTxt}
                        glowColor={plan.featured ? COLORS.primaryBlue : COLORS.textSecondary}
                      />
                    ) : null}

                    <Box sx={{ width: '100%', mt: 2 }}>
                      <Typography sx={{ fontSize: '16px', fontWeight: 600, color: plan.featured ? COLORS.primaryBlue : COLORS.textPrimary, mb: 1.5, mt: 2 }}>
                        Plan Includes
                      </Typography>
                      {plan.features.map((feature) => (
                        <FeatureItem
                          key={feature}
                          icon={<CheckIcon sx={{ color: COLORS.success }} />}
                          text={feature}
                          highlight={true}
                        />
                      ))}
                    </Box>

                    <Box sx={{ flexGrow: 1, minHeight: 72 }} />
                    <Button sx={modernButtonSX} onClick={() => handleNamedPlanClick(plan.planName)}>
                      {`Purchase ${plan.title} Plan`}
                    </Button>
                  </Card>
                </motion.div>
              </Grid>
            );
          })}
        </Grid>
        </>
        :
      <></>}

      {/* Purchase popup note kept subtle to avoid competing with pricing CTAs */}
         { exchange === EXCHANGE_MODES.BSE_TOP_UP && !isError && !isErrorUserSubs && (
            <Typography
            sx={{
               mt: 2,
               mb: 1,
               textAlign: 'center',
               fontSize: '16px',
               color: COLORS.textSecondary,
               fontWeight: 600,
               opacity: 1,
            }}
            >
            *PRO RATA: Final price as shown on the Purchase Details popup.
            </Typography>
         )}

      {/* ECourse Section - Horizontal Banner */}
      {!isError && !isErrorUserSubs ? (
      <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center', px: 2 }}>
         <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
         >
            <Card sx={{
            maxWidth: 1200,
            width: '100%',
            minHeight: 180,
            display: 'flex',
            flexDirection: 'row',                        
            '@media (max-width: 1023px)': {
               flexDirection: 'column',                  
               padding: 3,                               
            },
            alignItems: 'stretch',
            padding: 5,
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid ${COLORS.borderLight}`,
            position: 'relative',
            transition: 'all 0.3s ease',
            "&:hover": {
               borderColor: COLORS.borderHover,
               transform: 'translateY(-4px)',
               boxShadow: '0 12px 30px rgba(54, 194, 180, 0.18)'
            }
            }}>
            {/* ONE-TIME PURCHASE Badge */}
            <Box sx={{
               position: 'absolute',
               top: 8,
               right: 8,
               padding: '3px 10px',
               borderRadius: 12,
               fontSize: '0.7rem',
               fontWeight: 600,
               background: 'rgba(251, 225, 3, 0.1)',
               color: '#FBE103',
               border: '1px solid rgba(251, 225, 3, 0.3)',
               zIndex: 1,
               letterSpacing: '0.3px'
            }}>
               ONE-TIME PURCHASE
            </Box>
            
            {/* Left Section - Title and Special Offer */}
            <Box sx={{ 
               flex: 1, 
               pr: 6,                                    
               '@media (max-width: 1023px)': {
                  pr: 0,                                 
                  pb: 3,                                 
               },
               display: 'flex', 
               flexDirection: 'column', 
               justifyContent: 'center',
               minHeight: '100%'
            }}>
               <Box sx={{ mb: 4 }}>
                  <Typography sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  color: COLORS.textPrimary,
                  mb: 1,
                  textAlign: 'left',
                  lineHeight: 1.3
                  }}>
                  MarketProfile and Orderflow Trading Strategies
                  </Typography>
                  <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: '#FBE103',
                  mb: 3,
                  textAlign: 'left'
                  }}>
                  ECourse Subscription
                  </Typography>
                  
                  <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  textAlign: 'left',
                  lineHeight: 1.6
                  }}>
                  Special Offer - Get FREE<sup>#</sup> 15 day access to Elite Index only plan which gives you Orderflow charts for Index instruments and Complete Options Suite access worth <strong style={{ color: '#FBE103' }}><RupeeSymbol />2500</strong> + GST
                  </Typography>
               </Box>
            </Box>
                  
            {/* Right Section - Price, Button and Terms */}
            <Box sx={{ 
               flex: 1, 
               pl: 21,                                   
               pr: 0.5,
               '@media (max-width: 1023px)': {
                  pl: 0,                                 
                  pr: 0,                                 
               },
               display: 'flex', 
               flexDirection: 'column', 
               justifyContent: 'center',
               minHeight: '100%'
            }}>
               {/* Price Section */}
               <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  mb: 2
               }}>
                  <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'baseline',
                  gap: 2,
                  flexWrap: 'wrap',
                  mb: 0.5
                  }}>
                  <Typography sx={{
                     fontSize: "48px",
                     fontWeight: 700,
                     color: '#FBE103',
                     textAlign: 'left',
                     lineHeight: 1
                  }}>
                     <RupeeSymbol />3539
                  </Typography>
                  <Typography sx={{
                     fontSize: "28px",
                     fontWeight: 500,
                     color: COLORS.textSecondary,
                     textAlign: 'left',
                     opacity: 0.8,
                     lineHeight: 1,
                     position: 'relative',
                     display: 'inline-block',
                     '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: 0,
                        right: 0,
                        height: '2px',
                        background: COLORS.textSecondary,
                        transform: 'rotate(-15deg)',
                        transformOrigin: 'center',
                     }
                  }}>
                     <RupeeSymbol />5899
                  </Typography>
                  </Box>
                  <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: COLORS.textSecondary,
                  textAlign: 'left',
                  ml: 1
                  }}>
                  (= 2999 + 540 GST)
                  </Typography>
               </Box>
               
               {/* Button Section */}
               <Box sx={{ mb: 3 }}>
                  <Button 
                  size="large" 
                  disabled={ecourseAlreadyBought} 
                  onClick={handleClickEcourse}
                  sx={{
                     width: 320,                         
                     '@media (max-width: 767px)': {
                        width: '100%',                   
                     },
                     fontSize: 16,
                     height: 48,
                     background: 'linear-gradient(135deg, #f8e325, #d4bf03)',
                     color: '#1a1a1a',
                     borderRadius: 3,
                     fontWeight: 600,
                     "&:hover": {
                        background: 'linear-gradient(135deg, #c9b717, #c6b303)',
                        boxShadow: '0 4px 15px rgba(245, 158, 11, 0.3)',
                        transform: 'translateY(-1px)',
                     },
                     "&:disabled": {
                        background: '#666',
                        color: '#999'
                     }
                  }}
                  >
                  {ecourseAlreadyBought ? "Bought" : "Buy ECourse Now*"}
                  </Button>
               </Box>
               
               {/* Terms Section */}
               <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  gap: 0.5
               }}>
                  <Typography sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  color: COLORS.textSecondary,
                  textAlign: 'left'
                  }}>
                  * Please Check the ECourse Terms & Conditions below
                  </Typography>
                  <Typography sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  color: COLORS.textSecondary,
                  textAlign: 'left'
                  }}>
                  <sup>#</sup> Non upgradable trial plan
                  </Typography>
               </Box>
            </Box>
            </Card>
         </motion.div>
      </Box>
      ) : (
      <></>
      )}

      {/* User Subscription Management Sections - Only show if user is logged in */}
      {auth?.accessToken && userSubsData && userSubsData.active_subscriptions && userSubsData.active_subscriptions.length > 0 ? (
        <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: '#E4EEE9',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: '2px solid #8FB5A6',
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: '#75998A',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(47, 93, 78, 0.16)'
            }
          }}>
            <Typography sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: '#2F5D4E',
              mb: 3,
              textAlign: 'center'
            }}>
              Active Subscription(s)
            </Typography>
            
            {userSubsData.active_subscriptions.map((item, index) => (
              <Box key={index} sx={{
                mb: 2,
                p: 2,
                backgroundColor: '#F3F7F5',
                borderRadius: 3,
                border: '1px solid #C5D9D0'
              }}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography sx={{ fontWeight: 600, minWidth: "140px", color: '#3D5C50' }}>
                    Plan Details:
                  </Typography>
                  <Typography sx={{ ml: 1, color: '#243F36' }}>
                    {item.description}
                  </Typography>
                    </Box>
                <Box sx={{ display: 'flex' }}>
                  <Typography sx={{ fontWeight: 600, minWidth: "140px", color: '#3D5C50' }}>
                    Expiry:
                    </Typography>
                  <Typography sx={{ ml: 1, color: '#243F36' }}>
                    {item.expiry_date} (in {item.days_to_expiry} days)
                  </Typography>
                </Box>
                </Box>
            ))}
            
            <Typography sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: '#5A736A',
              mt: 2,
              textAlign: 'center',
              lineHeight: 1.5
            }}>
              If you just subscribed and are unable to access resources as per your assigned plan, please relogin once and check again.
              <br/>Feel free to reach out to us at <Link href="mailto:charts@vtrender.com" sx={{ color: '#2F6F64', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>charts@vtrender.com</Link> in case of any issues or queries.
            </Typography>
          </Card>
                  </Box>
      ) : null}

      {auth?.accessToken && userSubsData && userSubsData.halted_subscriptions && userSubsData.halted_subscriptions.length > 0 ? (
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid #F59E0B`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: '#D97706',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(245, 158, 11, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#F59E0B",
              mb: 3,
              textAlign: 'center'
            }}>
              Halted Subscription(s)
            </Typography>
            
            {userSubsData.halted_subscriptions.map((item, index) => (
              <Box key={index} sx={{
                mb: 2,
                p: 2,
                backgroundColor: 'rgba(245, 158, 11, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(245, 158, 11, 0.1)'
              }}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography sx={{ fontWeight: 600, minWidth: "140px", color: COLORS.textPrimary }}>
                    Plan Details:
                  </Typography>
                  <Typography sx={{ ml: 1, color: COLORS.textPrimary }}>
                    {item.description}
                  </Typography>
                    </Box>
                <Box sx={{ display: 'flex' }}>
                  <Typography sx={{ fontWeight: 600, minWidth: "140px", color: COLORS.textPrimary }}>
                    Expiry:
                  </Typography>
                  <Typography sx={{ ml: 1, color: COLORS.textPrimary }}>
                    {item.expiry_date} (in {item.days_to_expiry} days)
                  </Typography>
                </Box>
                </Box>
            ))}
          </Card>
                 </Box>
      ) : null}

      {auth?.accessToken && userSubsData && userSubsData.pending_subscriptions && userSubsData.pending_subscriptions.length > 0 ? (
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid ${COLORS.primaryBlue}`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: COLORS.borderHover,
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(58, 134, 255, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: COLORS.primaryBlue,
              mb: 3,
              textAlign: 'center'
            }}>
              Pending Subscription(s)
            </Typography>
            
            {userSubsData.pending_subscriptions.map((item, index) => (
              <Box key={index} sx={{
                mb: 2,
                p: 2,
                backgroundColor: 'rgba(58, 134, 255, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(58, 134, 255, 0.1)'
              }}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography sx={{ fontWeight: 600, minWidth: "140px", color: COLORS.textPrimary }}>
                    Plan Details:
                  </Typography>
                  <Typography sx={{ ml: 1, color: COLORS.textPrimary }}>
                    {item.description}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex' }}>
                  <Typography sx={{ fontWeight: 600, minWidth: "140px", color: COLORS.textPrimary }}>
                    Status:
                  </Typography>
                  <Typography sx={{ ml: 1, color: COLORS.textPrimary }}>
                    {item.status}
                  </Typography>
                </Box>
                </Box>
            ))}
          </Card>
                </Box>
      ) : null}


      {/* Important Points Section - After ECourse Terms */}
      <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
        <Card sx={{
          maxWidth: 1200,
          width: '100%',
          backgroundColor: COLORS.cardBg,
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          borderRadius: 4,
          border: `2px solid ${COLORS.primaryBlue}`,
          padding: 4,
          transition: 'all 0.3s ease',
          "&:hover": {
            borderColor: COLORS.borderHover,
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(58, 134, 255, 0.15)'
          }
        }}>
          <Typography sx={{
            fontSize: "20px",
            fontWeight: 700,
            color: COLORS.textPrimary,
            mb: 3,
            textAlign: 'left'
          }}>
            Important points to note when subscribing to a new plan or upgrading from an existing plan:
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                Your name and contact details will be registered at NSE as a user of their live data till your plan stays active.
              </Typography>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                You can either upgrade your plan with higher privileges or safely add an Add-on to your existing plan from any of the options above.
              </Typography>
               </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0.5, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                In case of an upgrade, your old plan remaining benefits will be converted on pro-rata basis into the newly selected plan immediately and corresponding additional days will be added to your new plan as soon as you upgrade.
              </Typography>
               </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                In case of an Add-on on the existing plan, your active plan pending days for Expiry should get updated immediately.
              </Typography>
               </Box>
              
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                Any complementary plan that is bundled with ECourse is only for trial purposes. It does not come with a pro-rata upgrade ability.
              </Typography>
             </Box>
           
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                In case you opt for a downgrade when purchasing a new plan, we will activate the new plan automatically only after your current plan with higher privileges expires.
              </Typography>
        </Box>
      
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0.5, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                All paid subscription plans operate under the assumption of fair usage, wherein accounts are designated for individual use and should not be shared with any third parties or friends for any purpose.
              </Typography>
      </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <ArrowIcon fontSize='small' sx={{ color: COLORS.primaryBlue, mt: 0.5, flexShrink: 0 }} />
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.5
              }}>
                Any unauthorized simultaneous access to charts on different devices without prior written consent of Vtrender<sup>™</sup> Charts may incur penalties and you might get logged out of the website untimely and randomly, with possibility of account getting blocked permanently too.
              </Typography>
            </Box>
      </Box>
      </Card>
      </Box>

      {/* Price Change Notice - Styled Section */}
        <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid ${COLORS.success}`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: '#4CAF50',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(64, 182, 110, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: COLORS.textPrimary,
              textAlign: 'center',
              lineHeight: 1.6,
              mb: 2
            }}>
          Note: Prices are subject to change, and our plans may become more expensive in the future as we further enhance our services and develop more feature rich, unique and proprietary chart visualizations for you.
            </Typography>
            <Typography sx={{
              fontSize: "16px",
              fontWeight: 700,
              color: COLORS.success,
              textAlign: 'center',
              textDecoration: 'underline',
              textDecorationColor: COLORS.success
            }}>
              Subscribe now to secure the best possible rate for our services.
            </Typography>
          </Card>
        </Box>

        {/* Payment Information - Styled Section */}
        <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid ${COLORS.primaryBlue}`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: COLORS.borderHover,
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(58, 134, 255, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: COLORS.textPrimary,
              mb: 3,
              textAlign: 'center'
            }}>
              Alternative Payment Options
        </Typography>

            <Typography sx={{
              fontSize: "16px",
              fontWeight: 500,
              color: COLORS.textPrimary,
              mb: 3,
              textAlign: 'center',
              lineHeight: 1.5
            }}>
              In case you are not able to use the above payment options, please use the following QR code for making payments via any UPI application:
          </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <img 
                src={upiImg} 
                alt="vtrendercharts@icici" 
                width={200} 
                height={200} 
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                }}
              />
            </Box>

            <Typography sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: COLORS.primaryBlue,
              textAlign: 'center',
              mb: 3
            }}>
              UPI ID: <u>vtrendercharts@icici</u>
        </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <Typography sx={{ color: COLORS.primaryBlue, fontSize: '16px', fontWeight: 600 }}>•</Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  Please send a screenshot of the payment success page which has the Transaction Reference Number, your login Email ID and the details of subscription plan applied for to <Link href="mailto:charts@vtrender.com" sx={{ color: COLORS.primaryBlue, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>charts@vtrender.com</Link> so that we can process your payment.
        </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <Typography sx={{ color: COLORS.primaryBlue, fontSize: '16px', fontWeight: 600 }}>•</Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  Please allow for a time of around 12-24 hours for the subscription to be activated.
        </Typography>
              </Box>
            </Box>
          </Card>
        </Box>

      {/* ECourse Terms & Conditions - Immediately after ECourse Banner */}
      {!isError && !isErrorUserSubs ? (
        <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid #FBE103`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: '#E7B401',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(251, 225, 3, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#FBE103",
              mb: 3,
              textAlign: 'center',
              textDecoration: 'underline',
              textDecorationColor: '#E7B401'
            }}>
              ECourse Terms & Conditions
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '140px',
                  flexShrink: 0
                }}>
                  ECourse Activation:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The activation of ECourse is a manual step and though we try to do it ASAP, but please allow for a time of around 12-24 hours for the subscription to be activated.
               </Typography>
             </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  One-Time Access:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The purchase grants the user a one-time access to the ECourse on Financial Markets & Trading Strategies.
              </Typography>
           </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  No Recurring Fees:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The mentioned fee for the ECourse is a one-time charge. There will be no recurring charges or subscription fees after the initial payment.
                </Typography>
                 </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  ECourse Content:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The current plan offers access to 12 Expert-Led Online Video Tutorials. Any additional content, including but not limited to supplementary materials, handouts, or quizzes, is not guaranteed unless explicitly mentioned.
                </Typography>
                </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  Future Courses Exclusion:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  This purchase does not include access to any future courses, updates, or additions that may be made. Future courses or updates will need to be purchased separately.
                </Typography>
              </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  No Refunds:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  Once the purchase is made, no refunds are possible under any circumstances. Ensure you have read all the course details and terms before making the purchase.
                </Typography>
                   </Box>
                   
              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  Usage Limitation:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The purchased ECourse is for the individual use of the purchaser only. Sharing, distributing, or reproducing the content in any form is strictly prohibited and will result in immediate termination of access without any refunds.
                </Typography>
               </Box>
                  
              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  Expert Guidance:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  While our experts have vast experience and provide valuable insights, it's important to understand that trading and investment decisions should be made based on one's own judgment. We do not guarantee any specific financial outcomes or results from following our guidance.
                </Typography>
               </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  Continuous Learning:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The derivatives markets and trading strategies evolve over time. It's important to keep updating your knowledge and not solely rely on the current content of this ECourse for long-term trading decisions.
                </Typography>
                </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  Rate Changes:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The price for the ECourse, as mentioned, is subject to change without any prior notice. The rate at the time of purchase is final.
                </Typography>
                 </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(251, 225, 3, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(251, 225, 3, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FBE103",
                  minWidth: '150px',
                  maxWidth: '150px',
                  flexShrink: 0
                }}>
                  Complementary Benefits:
                </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
                  The Complementary 8-day Elite plan bundled with ECourse enables you to try out all chart features and it also gives you limited Orderflow charts access for Index Instruments only.
                </Typography>
                   </Box>
               </Box>
          </Card>
               </Box>
      ) : (
        <></>
      )}


        <Box sx={{ mt: 4, mb: 2, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setShowSubscriberAgreement(true)}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              fontSize: 15,
              px: 3,
              py: 1.25,
              borderRadius: '4px',
              color: COLORS.textPrimary,
              borderColor: COLORS.eliteOrange,
              '&:hover': {
                borderColor: COLORS.eliteOrangeDark,
                backgroundColor: 'rgba(242, 160, 96, 0.12)',
              },
            }}
          >
            View Subscriber Agreement &amp; Data Usage Terms
          </Button>
        </Box>
      
        {/* Disclaimer - Styled Section */}
        <Box sx={{ mt: 4, mb: 2, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid #FF6B6B`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: '#FF5252',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(255, 107, 107, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#FF6B6B",
              mb: 3,
              textAlign: 'center',
              textDecoration: 'underline',
              textDecorationColor: '#FF5252'
            }}>
          Disclaimer
        </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
        Although information has been obtained from and is based upon sources we believe to be reliable, we do not guarantee its accuracy and the information may be incomplete or condensed. This Website is for informational and analytical purposes only and none of the stock information, data and company information presented herein constitutes a legally binding recommendation or a solicitation of any offer to buy or sell any securities. Information presented is general information that does not take into account your individual circumstances, financial situation, or needs, nor does it present a personalized recommendation to you. Individual stocks presented may not be suitable for you.
              </Typography>

              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
        Any opinions, chats, messages, news, research, analyses, prices, or other information contained on this Website are provided as general market information for educational and entertainment purposes only, and do not constitute investment advice. The Website should not be relied upon as a substitute for extensive independent market research before making your actual trading decisions. Opinions, market data, recommendations or any other content is subject to change at any time without notice. Vtrender<sup>™</sup> Charts will not accept liability for any loss or damage, including without limitation any loss of profit, which may arise directly or indirectly from use of or reliance on such information. Vtrender<sup>™</sup> Charts is a research and information company and not investment/trading adviser. Please consult an adviser about the appropriateness of your investment/trading decisions.
        </Typography>

              <Box sx={{
                p: 2,
                backgroundColor: 'rgba(255, 107, 107, 0.05)',
                borderRadius: 3,
                border: '1px solid rgba(255, 107, 107, 0.1)'
              }}>
                <Typography sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#FF6B6B",
                  mb: 1
                }}>
                  Important Note:
        </Typography>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.5
                }}>
        Vtrender<sup>™</sup> Charts is not acting as an Investment Adviser or Research Analyst, and the Services do not provide personalised investment advice or security-specific recommendations.
        </Typography>
              </Box>
            </Box>
          </Card>
        </Box>
        <AppErrorPopup
          open={open}
          message={msg}
          severity={severity}
          onClose={handleClose}
          showCloseX
        />
        {/* Legacy snackbar (replaced by AppErrorPopup)
        <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION_SHORT} >
          <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>
        */}
       {showorderPopup?
        <OrderDetailPopup data={orderDetailsData} planName={planName} onProceed={continuePayment} onCancel={()=>setShowOrderPopup(false)}></OrderDetailPopup>
        :
        <></>
       }
         {showLoginPopup?
          <LoginModal variant="sessionExpired" open onClose={()=>setShowLoginPopup(false)} msg={loginMsg}></LoginModal>  :
         <></>}

        {/* Cancellations and Refunds - Styled Section */}
        <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', px: 2 }}>
          <Card sx={{
            maxWidth: 1200,
            width: '100%',
            backgroundColor: COLORS.cardBg,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: `2px solid #F59E0B`,
            padding: 4,
            transition: 'all 0.3s ease',
            "&:hover": {
              borderColor: '#D97706',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(245, 158, 11, 0.15)'
            }
          }}>
            <Typography sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#F59E0B",
              mb: 3,
              textAlign: 'center',
              textDecoration: 'underline',
              textDecorationColor: '#D97706'
            }}>
              Cancellations and Refunds for Products
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
                We are committed to providing you with the highest quality service possible. However, please be advised that our charting service is a digital product and as such, we do not offer refunds once the service has been purchased and access has been granted.
              </Typography>

              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
                In order to ensure your satisfaction with our charting service, we recommend that you carefully review all product information, including the product description, before making a purchase. If you have any questions or concerns about the product, please feel free to contact us prior to making a purchase.
              </Typography>

              {/* No Refunds list */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: COLORS.textPrimary,
                  lineHeight: 1.6
                }}>
                  By purchasing our charting service, you acknowledge and agree that you understand that there will be no refunds for any reason, including but not limited to:
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <Typography sx={{ color: COLORS.primaryBlue, fontSize: '16px', fontWeight: 600 }}>•</Typography>
                  <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.5 }}>Dissatisfaction with the product or its performance</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <Typography sx={{ color: COLORS.primaryBlue, fontSize: '16px', fontWeight: 600 }}>•</Typography>
                  <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.5 }}>Technical difficulties or issues with accessing the service</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <Typography sx={{ color: COLORS.primaryBlue, fontSize: '16px', fontWeight: 600 }}>•</Typography>
                  <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.5 }}>Change of mind or circumstances</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <Typography sx={{ color: COLORS.primaryBlue, fontSize: '16px', fontWeight: 600 }}>•</Typography>
                  <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.5 }}>Inability to use the product due to technical requirements or compatibility issues</Typography>
                </Box>
              </Box>

              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
                If you have any technical issues with accessing the charting service, please contact us immediately so that we can assist you in resolving the issue. We provide you with the best possible experience and will work to resolve any technical difficulties in a timely manner.
              </Typography>

              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
                Please note that our no refund policy is a fundamental part of our charting service and is non-negotiable. By purchasing and accessing the charting service, you agree to be bound by this policy.
              </Typography>

              <Typography sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: COLORS.textPrimary,
                lineHeight: 1.6,
                textAlign: 'justify'
              }}>
                If you have any questions or concerns about our no refund policy, please feel free to contact us.
              </Typography>

              {/* No Refund Policy Subsection */}
              <Box sx={{
                p: 2,
                backgroundColor: 'rgba(245, 158, 11, 0.08)',
                borderRadius: 3,
                border: '1px solid rgba(245, 158, 11, 0.2)'
              }}>
                <Typography sx={{
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#F59E0B",
                  mb: 1,
                  textAlign: 'left'
                }}>
                  No Refund Policy
                </Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.6, mb: 1 }}>
                  Vtrender<sup>™</sup> Charts provides a comprehensive charting service product and ensures the highest quality of service to our clients. However, please note that due to the nature of our services, we have a strict no refund policy. All sales are final, and no refunds will be issued for any reason, including but not limited to dissatisfaction with the product, changes in personal circumstances, or technical difficulties.
                </Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.6, mb: 1 }}>
                  By purchasing our charting service product, you acknowledge and agree to our no refund policy and that your purchase is a one-time transaction and non-refundable. Vtrender<sup>™</sup> Charts is not responsible for any inconvenience or loss that may result from using our services.
                </Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: COLORS.textPrimary, lineHeight: 1.6 }}>
                  If you have any questions or concerns about our charting service product or no refund policy, please contact us before making a purchase. Our customer service team will be happy to assist you and answer any questions you may have.
                </Typography>
              </Box>
            </Box>
          </Card>
        </Box>

      </Box>
      </div>
      </MainLayoutContainer> :
        <div  style={{textAlign:"center", width:"100%"}}><CircularProgress sx={{marginTop:"10%"}}/>
        </div>}

      <SubscriberAgreementPopup
        open={showSubscriberAgreement}
        readOnly
        onClose={() => setShowSubscriberAgreement(false)}
      />
      </>          
       
    )
}

export default Pricing
